var quizQuestions = [
  {
    id: '1',
    question: 'In Deutschland dürfen Menschen offen etwas gegen die Regierung sagen, weil ...',
    answers: [
      {
        content: 'hier Religionsfreiheit gilt.',
        key: 0,
      },
      {
        content: 'die Menschen Steuern zahlen.',
        key: 0,
      },
      {
        content: 'die Menschen das Wahlrecht haben.',
        key: 0,
      },
      {
        content: 'hier Meinungsfreiheit gilt.',
        key: 1,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '2',
    question: 'In Deutschland können Eltern bis zum 14. Lebensjahr ihres Kindes entscheiden, ob es in der Schule am...',
    answers: [
      {
        content: 'Geschichtsunterricht teilnimmt.',
        key: 0,
      },
      {
        content: 'Religionsunterricht teilnimmt.',
        key: 1,
      },
      {
        content: 'Politikunterricht teilnimmt.',
        key: 0,
      },
      {
        content: 'Sprachunterricht teilnimmt.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '3',
    question: 'Deutschland ist ein Rechtsstaat. Was ist damit gemeint?',
    answers: [
      {
        content: 'Alle Einwohner / Einwohnerinnen und der Staat müssen sich an die Gesetze halten.',
        key: 1,
      },
      {
        content: 'Der Staat muss sich nicht an die Gesetze halten.',
        key: 0,
      },
      {
        content: 'Nur Deutsche müssen die Gesetze befolgen.',
        key: 0,
      },
      {
        content: 'Die Gerichte machen die Gesetze.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '4',
    question: 'Welches Recht gehört zu den Grundrechten in Deutschland?',
    answers: [
      {
        content: 'Waffenbesitz',
        key: 0,
      },
      {
        content: 'Faustrecht',
        key: 0,
      },
      {
        content: 'Meinungsfreiheit',
        key: 1,
      },
      {
        content: 'Selbstjustiz',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '5',
    question: 'Wahlen in Deutschland sind frei. Was bedeutet das?',
    answers: [
      {
        content: 'Man darf Geld annehmen, wenn man dafür einen bestimmten Kandidaten / eine bestimmte Kandidatin wählt.',
        key: 0,
      },
      {
        content: 'Nur Personen, die noch nie im Gefängnis waren, dürfen wählen.',
        key: 0,
      },
      {
        content:
          'Der Wähler darf bei der Wahl weder beeinflusst noch zu einer bestimmten Stimmabgabe gezwungen werden und keine Nachteile durch die Wahl haben.',
        key: 1,
      },
      {
        content: 'Alle wahlberechtigten Personen müssen wählen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '6',
    question: 'Wie heißt die deutsche Verfassung?',
    answers: [
      {
        content: 'Volksgesetz',
        key: 0,
      },
      {
        content: 'Bundesgesetz',
        key: 0,
      },
      {
        content: 'Deutsches Gesetz',
        key: 0,
      },
      {
        content: 'Grundgesetz',
        key: 1,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '7',
    question: 'Welches Recht gehört zu den Grundrechten, die nach der deutschen Verfassung garantiert werden? Das Recht auf...',
    answers: [
      {
        content: 'Glaubens- und Gewissensfreiheit.',
        key: 1,
      },
      {
        content: 'Unterhaltung.',
        key: 0,
      },
      {
        content: 'Arbeit.',
        key: 0,
      },
      {
        content: 'Wohnung.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '8',
    question: 'Was steht nicht im Grundgesetz von Deutschland?',
    answers: [
      {
        content: 'Die Würde des Menschen ist unantastbar.',
        key: 0,
      },
      {
        content: 'Alle sollen gleich viel Geld haben.',
        key: 1,
      },
      {
        content: 'Jeder Mensch darf seine Meinung sagen.',
        key: 0,
      },
      {
        content: 'Alle sind vor dem Gesetz gleich.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '9',
    question: 'Welches Grundrecht gilt in Deutschland nur für Ausländer / Ausländerinnen? Das Grundrecht auf...',
    answers: [
      {
        content: 'Schutz der Familie',
        key: 0,
      },
      {
        content: 'Menschenwürde',
        key: 0,
      },
      {
        content: 'Asyl',
        key: 1,
      },
      {
        content: 'Meinungsfreiheit',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '10',
    question: 'Was ist mit dem deutschen Grundgesetz vereinbar?',
    answers: [
      {
        content: 'die Prügelstrafe',
        key: 0,
      },
      {
        content: 'die Folter',
        key: 0,
      },
      {
        content: 'die Todesstrafe',
        key: 0,
      },
      {
        content: 'die Geldstrafe',
        key: 1,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '11',
    question: 'Wie wird die Verfassung der Bundesrepublik Deutschland genannt?',
    answers: [
      {
        content: 'Grundgesetz',
        key: 1,
      },
      {
        content: 'Bundesverfassung',
        key: 0,
      },
      {
        content: 'Gesetzbuch',
        key: 0,
      },
      {
        content: 'Verfassungsvertrag',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '12',
    question: 'Eine Partei im Deutschen Bundestag will die Pressefreiheit abschaffen. Ist das möglich?',
    answers: [
      {
        content: 'Ja, wenn mehr als die Hälfte der Abgeordneten im Bundestag dafür sind.',
        key: 0,
      },
      {
        content: 'Ja, aber dazu müssen zwei Drittel der Abgeordneten im Bundestag dafür sein.',
        key: 0,
      },
      {
        content: 'Nein, denn die Pressefreiheit ist ein Grundrecht. Sie kann nicht abgeschafft werden.',
        key: 1,
      },
      {
        content: 'Nein, denn nur der Bundesrat kann die Pressefreiheit abschaffen.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '13',
    question: 'Im Parlament steht der Begriff \u201eOpposition\u201c für...',
    answers: [
      {
        content: 'die regierenden Parteien.',
        key: 0,
      },
      {
        content: 'die Fraktion mit den meisten Abgeordneten.',
        key: 0,
      },
      {
        content: 'alle Parteien, die bei der letzten Wahl die 5%-Hürde erreichen konnten.',
        key: 0,
      },
      {
        content: 'alle Abgeordneten, die nicht zu der Regierungspartei/den Regierungsparteien gehören.',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '14',
    question: 'Meinungsfreiheit in Deutschland heißt, dass ich...',
    answers: [
      {
        content: 'auf Flugblättern falsche Tatsachen behaupten darf.',
        key: 0,
      },
      {
        content: 'meine Meinung in Leserbriefen äußern kann.',
        key: 1,
      },
      {
        content: 'Nazi-Symbole tragen darf.',
        key: 0,
      },
      {
        content: 'Meine Meinung sagen darf, solange ich der Regierung nicht widerspreche.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '15',
    question: 'Was verbietet das deutsche Grundgesetz?',
    answers: [
      {
        content: 'Militärdienst',
        key: 0,
      },
      {
        content: 'Zwangsarbeit',
        key: 1,
      },
      {
        content: 'freie Berufswahl',
        key: 0,
      },
      {
        content: 'Arbeit im Ausland',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '16',
    question: 'Wann ist die Meinungsfreiheit in Deutschland eingeschränkt?',
    answers: [
      {
        content: 'bei der öffentlichen Verbreitung falscher Behauptungen über einzelne Personen',
        key: 1,
      },
      {
        content: 'bei Meinungsäußerungen über die Bundesregierung',
        key: 0,
      },
      {
        content: 'bei Diskussionen über Religionen',
        key: 0,
      },
      {
        content: 'bei Kritik am Staat',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '17',
    question: 'Die deutschen Gesetze verbieten...',
    answers: [
      {
        content: 'Meinungsfreiheit der Einwohner und Einwohnerinnen.',
        key: 0,
      },
      {
        content: 'Petitionen der Bürger und Bürgerinnen.',
        key: 0,
      },
      {
        content: 'Versammlungsfreiheit der Einwohner und Einwohnerinnen.',
        key: 0,
      },
      {
        content: 'Ungleichbehandlung der Bürger und Bürgerinnen durch den Staat.',
        key: 1,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '18',
    question: 'Welches Grundrecht ist in Artikel 1 des Grundgesetzes der Bundesrepublik Deutschland garantiert?',
    answers: [
      {
        content: 'die Unantastbarkeit der Menschenwürde',
        key: 1,
      },
      {
        content: 'das Recht auf Leben',
        key: 0,
      },
      {
        content: 'Religionsfreiheit',
        key: 0,
      },
      {
        content: 'Meinungsfreiheit',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '19',
    question: 'Was versteht man unter dem Recht der \u201eFreizügigkeit\u201c in Deutschland?',
    answers: [
      {
        content: 'Man darf sich seinen Wohnort selbst aussuchen.',
        key: 1,
      },
      {
        content: 'Man kann seinen Beruf wechseln.',
        key: 0,
      },
      {
        content: 'Man darf sich für eine andere Religion entscheiden.',
        key: 0,
      },
      {
        content: 'Man darf sich in der \u00d6ffentlichkeit nur leicht bekleidet bewegen.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '20',
    question: 'Eine Partei in Deutschland verfolgt das Ziel, eine Diktatur zu errichten. Sie ist dann ...',
    answers: [
      {
        content: 'tolerant.',
        key: 0,
      },
      {
        content: 'rechtsstaatlich orientiert.',
        key: 0,
      },
      {
        content: 'gesetzestreu.',
        key: 0,
      },
      {
        content: 'verfassungswidrig.',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '21',
    question: 'Welches ist das Wappen der Bundesrepublik Deutschland?',
    image: '021',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Staatssymbole',
  },
  {
    id: '22',
    question: 'Was für eine Staatsform hat Deutschland?',
    answers: [
      {
        content: 'Monarchie',
        key: 0,
      },
      {
        content: 'Diktatur',
        key: 0,
      },
      {
        content: 'Republik',
        key: 1,
      },
      {
        content: 'Fürstentum',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '23',
    question: 'In Deutschland sind die meisten Erwerbstätigen...',
    answers: [
      {
        content: 'in kleinen Familienunternehmen beschäftigt.',
        key: 0,
      },
      {
        content: 'ehrenamtlich für ein Bundesland tätig.',
        key: 0,
      },
      {
        content: 'selbständig mit einer eigenen Firma tätig.',
        key: 0,
      },
      {
        content: 'bei einer Firma oder Behörde beschäftigt.',
        key: 1,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '24',
    question: 'Wie viele Bundesländer hat die Bundesrepublik Deutschland?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '15',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '17',
        key: 0,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '25',
    question: 'Was ist kein Bundesland der Bundesrepublik Deutschland?',
    answers: [
      {
        content: 'Elsass-Lothringen',
        key: 1,
      },
      {
        content: 'Nordrhein-Westfalen',
        key: 0,
      },
      {
        content: 'Mecklenburg-Vorpommern',
        key: 0,
      },
      {
        content: 'Sachsen-Anhalt',
        key: 0,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '26',
    question: 'Deutschland ist...',
    answers: [
      {
        content: 'eine kommunistische Republik.',
        key: 0,
      },
      {
        content: 'ein demokratischer und sozialer Bundesstaat.',
        key: 1,
      },
      {
        content: 'eine kapitalistische und soziale Monarchie.',
        key: 0,
      },
      {
        content: 'ein sozialer und sozialistischer Bundesstaat.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '27',
    question: 'Deutschland ist...',
    answers: [
      {
        content: 'ein sozialistischer Staat.',
        key: 0,
      },
      {
        content: 'ein Bundesstaat.',
        key: 1,
      },
      {
        content: 'eine Diktatur.',
        key: 0,
      },
      {
        content: 'eine Monarchie.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '28',
    question: 'Wer wählt in Deutschland die Abgeordneten zum Bundestag?',
    answers: [
      {
        content: 'das Militär',
        key: 0,
      },
      {
        content: 'die Wirtschaft',
        key: 0,
      },
      {
        content: 'das wahlberechtigte Volk',
        key: 1,
      },
      {
        content: 'die Verwaltung',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '29',
    question: 'Welches Tier ist das Wappentier der Bundesrepublik Deutschland?',
    answers: [
      {
        content: 'Löwe',
        key: 0,
      },
      {
        content: 'Adler',
        key: 1,
      },
      {
        content: 'Bär',
        key: 0,
      },
      {
        content: 'Pferd',
        key: 0,
      },
    ],
    category: 'Staatssymbole',
  },
  {
    id: '30',
    question: 'Was ist kein Merkmal unserer Demokratie?',
    answers: [
      {
        content: 'regelmäßige Wahlen',
        key: 0,
      },
      {
        content: 'Pressezensur',
        key: 1,
      },
      {
        content: 'Meinungsfreiheit',
        key: 0,
      },
      {
        content: 'verschiedene Parteien',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '31',
    question: 'Die Zusammenarbeit von Parteien zur Bildung einer Regierung nennt man in Deutschland...',
    answers: [
      {
        content: 'Einheit.',
        key: 0,
      },
      {
        content: 'Koalition.',
        key: 1,
      },
      {
        content: 'Ministerium.',
        key: 0,
      },
      {
        content: 'Fraktion.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '32',
    question: 'Was ist keine staatliche Gewalt in Deutschland?',
    answers: [
      {
        content: 'Gesetzgebung',
        key: 0,
      },
      {
        content: 'Regierung',
        key: 0,
      },
      {
        content: 'Presse',
        key: 1,
      },
      {
        content: 'Rechtsprechung',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '33',
    question: 'Welche Aussage ist richtig? In Deutschland...',
    answers: [
      {
        content: 'sind Staat und Religionsgemeinschaften voneinander getrennt.',
        key: 1,
      },
      {
        content: 'bilden die Religionsgemeinschaften den Staat.',
        key: 0,
      },
      {
        content: 'ist der Staat abhängig von den Religionsgemeinschaften.',
        key: 0,
      },
      {
        content: 'bilden Staat und Religionsgemeinschaften eine Einheit.',
        key: 0,
      },
    ],
    category: 'Religiöse Vielfalt',
  },
  {
    id: '34',
    question: 'Was ist Deutschland nicht?',
    answers: [
      {
        content: 'eine Demokratie',
        key: 0,
      },
      {
        content: 'ein Rechtsstaat',
        key: 0,
      },
      {
        content: 'eine Monarchie',
        key: 1,
      },
      {
        content: 'ein Sozialstaat',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '35',
    question: 'Womit finanziert der deutsche Staat die Sozialversicherung?',
    answers: [
      {
        content: 'Kirchensteuern',
        key: 0,
      },
      {
        content: 'Sozialabgaben',
        key: 1,
      },
      {
        content: 'Spendengeldern',
        key: 0,
      },
      {
        content: 'Vereinsbeiträgen',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '36',
    question: 'Welche Maßnahme schafft in Deutschland soziale Sicherheit?',
    answers: [
      {
        content: 'die Krankenversicherung',
        key: 1,
      },
      {
        content: 'die Autoversicherung',
        key: 0,
      },
      {
        content: 'die Gebäudeversicherung',
        key: 0,
      },
      {
        content: 'die Haftpflichtversicherung',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '37',
    question: 'Wie werden die Regierungschefs / Regierungschefinnen der meisten Bundesländer in Deutschland genannt?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Senator / Senatorin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '38',
    question: 'Die Bundesrepublik Deutschland ist ein demokratischer und sozialer...',
    answers: [
      {
        content: 'Staatenverbund.',
        key: 0,
      },
      {
        content: 'Bundesstaat.',
        key: 1,
      },
      {
        content: 'Staatenbund.',
        key: 0,
      },
      {
        content: 'Zentralstaat.',
        key: 0,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '39',
    question: 'Was hat jedes deutsche Bundesland?',
    answers: [
      {
        content: 'einen eigenen Außenminister / eine eigene Außenministerin',
        key: 0,
      },
      {
        content: 'eine eigene Währung',
        key: 0,
      },
      {
        content: 'eine eigene Armee',
        key: 0,
      },
      {
        content: 'eine eigene Regierung',
        key: 1,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '40',
    question: 'Mit welchen Worten beginnt die deutsche Nationalhymne?',
    answers: [
      {
        content: 'Völker, hört die Signale...',
        key: 0,
      },
      {
        content: 'Einigkeit und Recht und Freiheit...',
        key: 1,
      },
      {
        content: 'Freude schöner Götterfunken...',
        key: 0,
      },
      {
        content: 'Deutschland einig Vaterland...',
        key: 0,
      },
    ],
    category: 'Staatssymbole',
  },
  {
    id: '41',
    question: 'Warum gibt es in einer Demokratie mehr als eine Partei?',
    answers: [
      {
        content: 'weil dadurch die unterschiedlichen Meinungen der Bürger und Bürgerinnen vertreten werden',
        key: 1,
      },
      {
        content: 'damit Bestechung in der Politik begrenzt wird',
        key: 0,
      },
      {
        content: 'um politische Demonstrationen zu verhindern',
        key: 0,
      },
      {
        content: 'um wirtschaftlichen Wettbewerb anzuregen',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '42',
    question: 'Wer beschließt in Deutschland ein neues Gesetz?',
    answers: [
      {
        content: 'die Regierung',
        key: 0,
      },
      {
        content: 'das Parlament',
        key: 1,
      },
      {
        content: 'die Gerichte',
        key: 0,
      },
      {
        content: 'die Polizei',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '43',
    question: 'Wann kann in Deutschland eine Partei verboten werden?',
    answers: [
      {
        content: 'wenn ihr Wahlkampf zu teuer ist',
        key: 0,
      },
      {
        content: 'wenn sie gegen die Verfassung kämpft',
        key: 1,
      },
      {
        content: 'wenn sie Kritik am Staatsoberhaupt äußert',
        key: 0,
      },
      {
        content: 'wenn ihr Programm eine neue Richtung vorschlägt',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '44',
    question: 'Wen kann man als Bürger / Bürgerin in Deutschland nicht direkt wählen?',
    answers: [
      {
        content: 'Abgeordnete des EU-Parlaments',
        key: 0,
      },
      {
        content: 'den Bundespräsidenten / die Bundespräsidentin',
        key: 1,
      },
      {
        content: 'Landtagsabgeordnete',
        key: 0,
      },
      {
        content: 'Bundestagsabgeordnete',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '45',
    question: 'Zu welcher Versicherung gehört die Pflegeversicherung?',
    answers: [
      {
        content: 'Sozialversicherung',
        key: 1,
      },
      {
        content: 'Unfallversicherung',
        key: 0,
      },
      {
        content: 'Hausratversicherung',
        key: 0,
      },
      {
        content: 'Haftpflicht- und Feuerversicherung',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '46',
    question: 'Der deutsche Staat hat viele Aufgaben. Welche Aufgabe gehört dazu?',
    answers: [
      {
        content: 'Er baut Straßen und Schulen.',
        key: 1,
      },
      {
        content: 'Er verkauft Lebensmittel und Kleidung.',
        key: 0,
      },
      {
        content: 'Er versorgt alle Einwohner und Einwohnerinnen kostenlos mit Zeitungen.',
        key: 0,
      },
      {
        content: 'Er produziert Autos und Busse.',
        key: 0,
      },
    ],
    category: 'Aufgaben des Staates',
  },
  {
    id: '47',
    question: 'Der deutsche Staat hat viele Aufgaben. Welche Aufgabe gehört nicht dazu?',
    answers: [
      {
        content: 'Er bezahlt für alle Staatsangehörigen Urlaubsreisen.',
        key: 1,
      },
      {
        content: 'Er zahlt Kindergeld.',
        key: 0,
      },
      {
        content: 'Er unterstützt Museen.',
        key: 0,
      },
      {
        content: 'Er fördert Sportler und Sportlerinnen.',
        key: 0,
      },
    ],
    category: 'Aufgaben des Staates',
  },
  {
    id: '48',
    question: 'Welches Organ gehört nicht zu den Verfassungsorganen Deutschlands?',
    answers: [
      {
        content: 'der Bundesrat',
        key: 0,
      },
      {
        content: 'der Bundespräsident / die Bundespräsidentin',
        key: 0,
      },
      {
        content: 'die Bürgerversammlung',
        key: 1,
      },
      {
        content: 'die Regierung',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '49',
    question: 'Wer bestimmt in Deutschland die Schulpolitik?',
    answers: [
      {
        content: 'die Lehrer und Lehrerinnen',
        key: 0,
      },
      {
        content: 'die Bundesländer',
        key: 1,
      },
      {
        content: 'das Familienministerium',
        key: 0,
      },
      {
        content: 'die Universitäten',
        key: 0,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '50',
    question: 'Die Wirtschaftsform in Deutschland nennt man...',
    answers: [
      {
        content: 'freie Zentralwirtschaft.',
        key: 0,
      },
      {
        content: 'soziale Marktwirtschaft.',
        key: 1,
      },
      {
        content: 'gelenkte Zentralwirtschaft.',
        key: 0,
      },
      {
        content: 'Planwirtschaft.',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '51',
    question: 'Zu einem demokratischen Rechtsstaat gehört es nicht, dass...',
    answers: [
      {
        content: 'Menschen sich kritisch über die Regierung äußern können.',
        key: 0,
      },
      {
        content: 'Bürger friedlich demonstrieren gehen dürfen.',
        key: 0,
      },
      {
        content: 'Menschen von einer Privatpolizei ohne Grund verhaftet werden.',
        key: 1,
      },
      {
        content: 'jemand ein Verbrechen begeht und deshalb verhaftet wird.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '52',
    question: 'Was bedeutet \u201eVolkssouveränität\u201c? Alle Staatsgewalt geht vom...',
    answers: [
      {
        content: 'Volke aus.',
        key: 1,
      },
      {
        content: 'Bundestag aus.',
        key: 0,
      },
      {
        content: 'preußischen König aus.',
        key: 0,
      },
      {
        content: 'Bundesverfassungsgericht aus.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '53',
    question: 'Was bedeutet \u201eRechtsstaat\u201c in Deutschland?',
    answers: [
      {
        content: 'Der Staat hat Recht.',
        key: 0,
      },
      {
        content: 'Es gibt nur rechte Parteien.',
        key: 0,
      },
      {
        content: 'Die Bürger und Bürgerinnen entscheiden über Gesetze.',
        key: 0,
      },
      {
        content: 'Der Staat muss die Gesetze einhalten.',
        key: 1,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '54',
    question: 'Was ist keine staatliche Gewalt in Deutschland?',
    answers: [
      {
        content: 'Legislative',
        key: 0,
      },
      {
        content: 'Judikative',
        key: 0,
      },
      {
        content: 'Exekutive',
        key: 0,
      },
      {
        content: 'Direktive',
        key: 1,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '55',
    question: 'Was zeigt dieses Bild?',
    image: '055',
    answers: [
      {
        content: 'den Bundestagssitz in Berlin',
        key: 1,
      },
      {
        content: 'das Bundesverfassungsgericht in Karlsruhe',
        key: 0,
      },
      {
        content: 'das Bundesratsgebäude in Berlin',
        key: 0,
      },
      {
        content: 'das Bundeskanzleramt in Berlin',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '56',
    question: 'Welches Amt gehört in Deutschland zur Gemeindeverwaltung?',
    answers: [
      {
        content: 'Pfarramt',
        key: 0,
      },
      {
        content: 'Ordnungsamt',
        key: 1,
      },
      {
        content: 'Finanzamt',
        key: 0,
      },
      {
        content: 'Auswärtiges Amt',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '57',
    question: 'Wer wird meistens zum Präsidenten / zur Präsidentin des Deutschen Bundestages gewählt?',
    answers: [
      {
        content: 'der / die älteste Abgeordnete im Parlament',
        key: 0,
      },
      {
        content: 'der Ministerpräsident / die Ministerpräsidentin des größten Bundeslandes',
        key: 0,
      },
      {
        content: 'ein Abgeordneter / eine Abgeordnete der stärksten Fraktion',
        key: 1,
      },
      {
        content: 'ein ehemaliger Bundeskanzler / eine ehemalige Bundeskanzlerin',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '58',
    question: 'Wer ernennt in Deutschland die Minister / die Ministerinnen der Bundesregierung?',
    answers: [
      {
        content: 'der Präsident / die Präsidentin des Bundesverfassungsgerichtes',
        key: 0,
      },
      {
        content: 'der Bundespräsident / die Bundespräsidentin',
        key: 1,
      },
      {
        content: 'der Bundesratspräsident / die Bundesratspräsidentin',
        key: 0,
      },
      {
        content: 'der Bundestagspräsident / die Bundestagspräsidentin',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '59',
    question: 'Welche Parteien wurden in Deutschland 2007 zur Partei \u201eDie Linke\u201c?',
    answers: [
      {
        content: 'CDU und SSW',
        key: 0,
      },
      {
        content: 'PDS und WASG',
        key: 1,
      },
      {
        content: 'CSU und FDP',
        key: 0,
      },
      {
        content: 'Bündnis 90/Die Grünen und SPD',
        key: 0,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '60',
    question: 'In Deutschland gehören der Bundestag und der Bundesrat zur...',
    answers: [
      {
        content: 'Exekutive.',
        key: 0,
      },
      {
        content: 'Legislative.',
        key: 1,
      },
      {
        content: 'Direktive.',
        key: 0,
      },
      {
        content: 'Judikative.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '61',
    question: 'Was bedeutet \u201eVolkssouveränität\u201c?',
    answers: [
      {
        content: 'Der König / die Königin herrscht über das Volk.',
        key: 0,
      },
      {
        content: 'Das Bundesverfassungsgericht steht über der Verfassung.',
        key: 0,
      },
      {
        content: 'Die Interessenverbände üben die Souveränität zusammen mit der Regierung aus.',
        key: 0,
      },
      {
        content: 'Die Staatsgewalt geht vom Volke aus.',
        key: 1,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '62',
    question: 'Wenn das Parlament eines deutschen Bundeslandes gewählt wird, nennt man das...',
    answers: [
      {
        content: 'Kommunalwahl.',
        key: 0,
      },
      {
        content: 'Landtagswahl.',
        key: 1,
      },
      {
        content: 'Europawahl.',
        key: 0,
      },
      {
        content: 'Bundestagswahl.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '63',
    question: 'Was gehört in Deutschland nicht zur Exekutive?',
    answers: [
      {
        content: 'die Polizei',
        key: 0,
      },
      {
        content: 'die Gerichte',
        key: 1,
      },
      {
        content: 'das Finanzamt',
        key: 0,
      },
      {
        content: 'die Ministerien',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '64',
    question: 'Die Bundesrepublik Deutschland ist heute gegliedert in...',
    answers: [
      {
        content: 'vier Besatzungszonen.',
        key: 0,
      },
      {
        content: 'einen Oststaat und einen Weststaat.',
        key: 0,
      },
      {
        content: '16 Kantone.',
        key: 0,
      },
      {
        content: 'Bund, Länder und Kommunen.',
        key: 1,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '65',
    question: 'Es gehört nicht zu den Aufgaben des Deutschen Bundestages, ...',
    answers: [
      {
        content: 'Gesetze zu entwerfen.',
        key: 0,
      },
      {
        content: 'die Bundesregierung zu kontrollieren.',
        key: 0,
      },
      {
        content: 'den Bundeskanzler / die Bundeskanzlerin zu wählen.',
        key: 0,
      },
      {
        content: 'das Bundeskabinett zu bilden.',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '66',
    question: 'Wer schrieb den Text zur deutschen Nationalhymne?',
    answers: [
      {
        content: 'Friedrich von Schiller',
        key: 0,
      },
      {
        content: 'Clemens Brentano',
        key: 0,
      },
      {
        content: 'Johann Wolfgang von Goethe',
        key: 0,
      },
      {
        content: 'Heinrich Hoffmann von Fallersleben ',
        key: 1,
      },
    ],
    category: 'Staatssymbole',
  },
  {
    id: '67',
    question: 'Was ist in Deutschland vor allem eine Aufgabe der Bundesländer?',
    answers: [
      {
        content: 'Verteidigungspolitik',
        key: 0,
      },
      {
        content: 'Außenpolitik',
        key: 0,
      },
      {
        content: 'Wirtschaftspolitik',
        key: 0,
      },
      {
        content: 'Schulpolitik',
        key: 1,
      },
    ],
    category: 'Föderalismus',
  },
  {
    id: '68',
    question: 'Warum kontrolliert der Staat in Deutschland das Schulwesen?',
    answers: [
      {
        content: 'weil es in Deutschland nur staatliche Schulen gibt',
        key: 0,
      },
      {
        content: 'weil alle Schüler und Schülerinnen einen Schulabschluss haben müssen',
        key: 0,
      },
      {
        content: 'weil es in den Bundesländern verschiedene Schulen gibt',
        key: 0,
      },
      {
        content: 'weil es nach dem Grundgesetz seine Aufgabe ist',
        key: 1,
      },
    ],
    category: 'Aufgaben des Staates',
  },
  {
    id: '69',
    question: 'Die Bundesrepublik Deutschland hat einen dreistufigen Verwaltungsaufbau. Wie heißt die unterste politische Stufe?',
    answers: [
      {
        content: 'Stadträte',
        key: 0,
      },
      {
        content: 'Landräte',
        key: 0,
      },
      {
        content: 'Gemeinden',
        key: 1,
      },
      {
        content: 'Bezirksämter',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '70',
    question:
      'Der deutsche Bundespräsident Gustav Heinemann gibt Helmut Schmidt 1974 die Ernennungsurkunde zum deutschen Bundeskanzler. Was gehört zu den Aufgaben des deutschen Bundespräsidenten / der deutschen Bundespräsidentin?',
    image: '070',
    answers: [
      {
        content: 'Er / Sie führt die Regierungsgeschäfte.',
        key: 0,
      },
      {
        content: 'Er / Sie kontrolliert die Regierungspartei.',
        key: 0,
      },
      {
        content: 'Er / Sie wählt die Minister / Ministerinnen aus.',
        key: 0,
      },
      {
        content: 'Er / Sie schlägt den Kanzler / die Kanzlerin zur Wahl vor.',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '71',
    question:
      'Wo hält sich der deutsche Bundeskanzler / die deutsche Bundeskanzlerin am häufigsten auf? Am häufigsten ist er / sie...',
    answers: [
      {
        content: 'in Bonn, weil sich dort das Bundeskanzleramt und der Bundestag befinden.',
        key: 0,
      },
      {
        content: 'in Berlin, weil sich dort das Bundeskanzleramt und der Bundestag befinden. ',
        key: 1,
      },
      {
        content: 'auf Schloss Meseberg, dem Gästehaus der Bundesregieung, um Staatsgäste zu empfangen.',
        key: 0,
      },
      {
        content:
          'auf Schloss Bellevue, dem Amtssitz des Bundespräsidenten / der Bundespräsidentin, um Staatsgäste zu empfangen.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '72',
    question: 'Wie heißt der jetzige Bundeskanzler / die jetzige Bundeskanzlerin von Deutschland?',
    answers: [
      {
        content: 'Gerhard Schröder',
        key: 0,
      },
      {
        content: 'Jürgen Rüttgers',
        key: 0,
      },
      {
        content: 'Klaus Wowereit',
        key: 0,
      },
      {
        content: 'Angela Merkel',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '73',
    question: 'Die beiden größten Fraktionen im Deutschen Bundestag heißen zurzeit...',
    answers: [
      {
        content: 'CDU/CSU und SPD.',
        key: 1,
      },
      {
        content: 'Die Linke und Bündnis 90/Die Grünen.',
        key: 0,
      },
      {
        content: 'FDP und SPD.',
        key: 0,
      },
      {
        content: 'Die Linke und FDP.',
        key: 0,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '74',
    question: 'Wie heißt das Parlament für ganz Deutschland?',
    answers: [
      {
        content: 'Bundesversammlung',
        key: 0,
      },
      {
        content: 'Volkskammer',
        key: 0,
      },
      {
        content: 'Bundestag',
        key: 1,
      },
      {
        content: 'Bundesgerichtshof',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '75',
    question: 'Wie heißt Deutschlands heutiges Staatsoberhaupt?',
    answers: [
      {
        content: 'Frank-Walter Steinmeier',
        key: 1,
      },
      {
        content: 'Joachim Gauck',
        key: 0,
      },
      {
        content: 'Norbert Lammert',
        key: 0,
      },
      {
        content: 'Wolfgang Thierse',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '76',
    question: 'Was bedeutet die Abkürzung CDU in Deutschland?',
    answers: [
      {
        content: 'Christliche Deutsche Union',
        key: 0,
      },
      {
        content: 'Club Deutscher Unternehmer',
        key: 0,
      },
      {
        content: 'Christlicher Deutscher Umweltschutz',
        key: 0,
      },
      {
        content: 'Christlich Demokratische Union',
        key: 1,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '77',
    question: 'Was ist die Bundeswehr?',
    answers: [
      {
        content: 'die deutsche Polizei',
        key: 0,
      },
      {
        content: 'ein deutscher Hafen',
        key: 0,
      },
      {
        content: 'eine deutsche Bürgerinitiative',
        key: 0,
      },
      {
        content: 'die deutsche Armee',
        key: 1,
      },
    ],
    category: 'Aufgaben des Staates',
  },
  {
    id: '78',
    question: 'Was bedeutet die Abkürzung SPD?',
    answers: [
      {
        content: 'Sozialistische Partei Deutschlands',
        key: 0,
      },
      {
        content: 'Sozialpolitische Partei Deutschlands',
        key: 0,
      },
      {
        content: 'Sozialdemokratische Partei Deutschlands',
        key: 1,
      },
      {
        content: 'Sozialgerechte Partei Deutschlands',
        key: 0,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '79',
    question: 'Was bedeutet die Abkürzung FDP in Deutschland?',
    answers: [
      {
        content: 'Friedliche Demonstrative Partei',
        key: 0,
      },
      {
        content: 'Freie Deutschland Partei',
        key: 0,
      },
      {
        content: 'Führende Demokratische Partei',
        key: 0,
      },
      {
        content: 'Freie Demokratische Partei',
        key: 1,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '80',
    question: 'Welches Gericht in Deutschland ist zuständig für die Auslegung des Grundgesetzes?',
    answers: [
      {
        content: 'Oberlandesgericht',
        key: 0,
      },
      {
        content: 'Amtsgericht',
        key: 0,
      },
      {
        content: 'Bundesverfassungsgericht',
        key: 1,
      },
      {
        content: 'Verwaltungsgericht',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '81',
    question: 'Wer wählt den Bundeskanzler / die Bundeskanzlerin in Deutschland?',
    answers: [
      {
        content: 'der Bundesrat',
        key: 0,
      },
      {
        content: 'die Bundesversammlung',
        key: 0,
      },
      {
        content: 'das Volk',
        key: 0,
      },
      {
        content: 'der Bundestag',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '82',
    question: 'Wer leitet das deutsche Bundeskabinett?',
    answers: [
      {
        content: 'der Bundestagspräsident / die Bundestagspräsidentin',
        key: 0,
      },
      {
        content: 'der Bundespräsident / die Bundespräsidentin',
        key: 0,
      },
      {
        content: 'der Bundesratspräsident / die Bundesratspräsidentin',
        key: 0,
      },
      {
        content: 'der Bundeskanzler / die Bundeskanzlerin',
        key: 1,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '83',
    question: 'Wer wählt den deutschen Bundeskanzler / die deutsche Bundeskanzlerin?',
    answers: [
      {
        content: 'das Volk',
        key: 0,
      },
      {
        content: 'die Bundesversammlung',
        key: 0,
      },
      {
        content: 'der Bundestag',
        key: 1,
      },
      {
        content: 'die Bundesregierung',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '84',
    question: 'Welche Hauptaufgabe hat der deutsche Bundespräsident / die deutsche Bundespräsidentin? Er / Sie...',
    answers: [
      {
        content: 'regiert das Land.',
        key: 0,
      },
      {
        content: 'entwirft die Gesetze.',
        key: 0,
      },
      {
        content: 'repräsentiert das Land.',
        key: 1,
      },
      {
        content: 'überwacht die Einhaltung der Gesetze.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '85',
    question: 'Wer bildet den deutschen Bundesrat?',
    answers: [
      {
        content: 'die Abgeordneten des Bundestages',
        key: 0,
      },
      {
        content: 'die Minister und Ministerinnen der Bundesregierung',
        key: 0,
      },
      {
        content: 'die Regierungsvertreter der Bundesländer',
        key: 1,
      },
      {
        content: 'die Parteimitglieder',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '86',
    question: 'Wer wählt in Deutschland den Bundespräsidenten / die Bundespräsidentin?',
    answers: [
      {
        content: 'die Bundesversammlung',
        key: 1,
      },
      {
        content: 'der Bundesrat',
        key: 0,
      },
      {
        content: 'das Bundesparlament',
        key: 0,
      },
      {
        content: 'das Bundesverfassungsgericht',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '87',
    question: 'Wer ist das Staatsoberhaupt der Bundesrepublik Deutschland?',
    answers: [
      {
        content: 'der Bundeskanzler / die Bundeskanzlerin',
        key: 0,
      },
      {
        content: 'der Bundespräsident / die Bundespräsidentin',
        key: 1,
      },
      {
        content: 'der Bundesratspräsident / die Bundesratspräsidentin',
        key: 0,
      },
      {
        content: 'der Bundestagspräsident / die Bundestagspräsidentin',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '88',
    question: 'Die parlamentarische Opposition im Deutschen Bundestag...',
    answers: [
      {
        content: 'kontrolliert die Regierung.',
        key: 1,
      },
      {
        content: 'entscheidet, wer Bundesminister / Bundesministerin wird.',
        key: 0,
      },
      {
        content: 'bestimmt, wer im Bundesrat sitzt.',
        key: 0,
      },
      {
        content: 'schlägt die Regierungschefs / Regierungschefinnen der Länder vor.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '89',
    question: 'Wie nennt man in Deutschland die Vereinigung von Abgeordneten einer Partei im Parlament?',
    answers: [
      {
        content: 'Verband',
        key: 0,
      },
      {
        content: 'Ältestenrat',
        key: 0,
      },
      {
        content: 'Fraktion',
        key: 1,
      },
      {
        content: 'Opposition',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '90',
    question: 'Die deutschen Bundesländer wirken an der Gesetzgebung des Bundes mit durch...',
    answers: [
      {
        content: 'den Bundesrat.',
        key: 1,
      },
      {
        content: 'die Bundesversammlung.',
        key: 0,
      },
      {
        content: 'den Bundestag.',
        key: 0,
      },
      {
        content: 'die Bundesregierung.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '91',
    question:
      'In Deutschland kann ein Regierungswechsel in einem Bundesland Auswirkungen auf die Bundespolitik haben. Das Regieren wird...',
    answers: [
      {
        content: 'schwieriger, wenn sich dadurch die Mehrheit im Bundestag ändert.',
        key: 0,
      },
      {
        content: 'leichter, wenn dadurch neue Parteien in den Bundesrat kommen.',
        key: 0,
      },
      {
        content: 'schwieriger, wenn dadurch die Mehrheit im Bundesrat verändert wird.',
        key: 1,
      },
      {
        content: 'leichter, wenn es sich um ein reiches Bundesland handelt.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '92',
    question: 'Was bedeutet die Abkürzung CSU in Deutschland?',
    answers: [
      {
        content: 'Christlich Sichere Union',
        key: 0,
      },
      {
        content: 'Christlich Süddeutsche Union',
        key: 0,
      },
      {
        content: 'Christlich Sozialer Unternehmerverband',
        key: 0,
      },
      {
        content: 'Christlich Soziale Union',
        key: 1,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '93',
    question: 'Je mehr \u201eZweitstimmen\u201c eine Partei bei einer Bundestagswahl bekommt, desto...',
    answers: [
      {
        content: 'mehr Sitze erhält die Partei im Parlament.',
        key: 1,
      },
      {
        content: 'weniger Erststimmen kann sie haben.',
        key: 0,
      },
      {
        content: 'mehr Direktkandidaten der Partei ziehen ins Parlament ein.',
        key: 0,
      },
      {
        content: 'größer ist das Risiko, eine Koalition bilden zu müssen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '94',
    question: 'Ab welchem Alter darf man in Deutschland an der Wahl zum Deutschen Bundestag teilnehmen?',
    answers: [
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '21',
        key: 0,
      },
      {
        content: '23',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '95',
    question: 'Was gilt für die meisten Kinder in Deutschland?',
    answers: [
      {
        content: 'Wahlpflicht',
        key: 0,
      },
      {
        content: 'Schulpflicht',
        key: 1,
      },
      {
        content: 'Schweigepflicht',
        key: 0,
      },
      {
        content: 'Religionspflicht',
        key: 0,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '96',
    question: 'Was muss jeder deutsche Staatsbürger / jede deutsche Staatsbürgerin ab dem 16. Lebensjahr besitzen?',
    answers: [
      {
        content: 'einen Reisepass',
        key: 0,
      },
      {
        content: 'einen Personalausweis',
        key: 1,
      },
      {
        content: 'einen Sozialversicherungsausweis',
        key: 0,
      },
      {
        content: 'einen Führerschein',
        key: 0,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '97',
    question: 'Was bezahlt man in Deutschland automatisch, wenn man fest angestellt ist?',
    answers: [
      {
        content: 'Sozialversicherung',
        key: 1,
      },
      {
        content: 'Sozialhilfe',
        key: 0,
      },
      {
        content: 'Kindergeld',
        key: 0,
      },
      {
        content: 'Wohngeld',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '98',
    question: 'Wenn Abgeordnete im Deutschen Bundestag ihre Fraktion wechseln, ...',
    answers: [
      {
        content: 'kann die Regierung ihre Mehrheit verlieren.',
        key: 1,
      },
      {
        content: 'dürfen sie nicht mehr an den Sitzungen des Parlaments teilnehmen.',
        key: 0,
      },
      {
        content: 'muss der Bundespräsident / die Bundespräsidentin zuvor sein / ihr Einverständnis geben.',
        key: 0,
      },
      {
        content: 'dürfen die Wähler / Wählerinnen dieser Abgeordneten noch einmal wählen.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '99',
    question: 'Wer bezahlt in Deutschland die Sozialversicherungen?',
    answers: [
      {
        content: 'Arbeitgeber / Arbeitgeberinnen und Arbeitnehmer / Arbeitnehmerinnen',
        key: 1,
      },
      {
        content: 'nur Arbeitnehmer / Arbeitnehmerinnen',
        key: 0,
      },
      {
        content: 'alle Staatsangehörigen',
        key: 0,
      },
      {
        content: 'nur Arbeitgeber / Arbeitgeberinnen',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '100',
    question: 'Was gehört nicht zur gesetzlichen Sozialversicherung?',
    answers: [
      {
        content: 'die gesetzliche Rentenversicherung',
        key: 0,
      },
      {
        content: 'die Lebensversicherung',
        key: 1,
      },
      {
        content: 'die Arbeitslosenversicherung',
        key: 0,
      },
      {
        content: 'die Pflegeversicherung',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '101',
    question: 'Gewerkschaften sind Interessenverbände der...',
    answers: [
      {
        content: 'Jugendlichen.',
        key: 0,
      },
      {
        content: 'Arbeitnehmer und Arbeitnehmerinnen.',
        key: 1,
      },
      {
        content: 'Rentner und Renterinnen.',
        key: 0,
      },
      {
        content: 'Arbeitgeber und Arbeitgeberinnen.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '102',
    question:
      'Womit kann man in der Bundesrepublik Deutschland geehrt werden, wenn man auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet eine besondere Leistung erbracht hat? Mit dem...',
    answers: [
      {
        content: 'Bundesadler',
        key: 0,
      },
      {
        content: 'Bundesverdienstkreuz',
        key: 1,
      },
      {
        content: 'Vaterländischen Verdienstorden',
        key: 0,
      },
      {
        content: 'Ehrentitel \u201eHeld der Deutschen Demokratischen Republik\u201c',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '103',
    question: 'Was wird in Deutschland als \u201eAmpelkoalition\u201c bezeichnet? Die Zusammenarbeit...',
    answers: [
      {
        content: 'der Bundestagsfraktionen von CDU und CSU',
        key: 0,
      },
      {
        content: 'von SPD, FDP und Bündnis 90/Die Grünen in einer Regierung',
        key: 1,
      },
      {
        content: 'von CSU, Die LINKE und Bündnis 90/Die Grünen in einer Regierung',
        key: 0,
      },
      {
        content: 'der Bundestagsfraktionen von CDU und SPD',
        key: 0,
      },
    ],
    category: 'Parteien',
  },
  {
    id: '104',
    question: 'Eine Frau in Deutschland verliert ihre Arbeit. Was darf nicht der Grund für diese Entlassung sein?',
    answers: [
      {
        content: 'Die Frau ist lange krank und arbeitsunfähig.',
        key: 0,
      },
      {
        content: 'Die Frau kam oft zu spät zur Arbeit.',
        key: 0,
      },
      {
        content: 'Die Frau erledigt private Sachen während der Arbeitszeit.',
        key: 0,
      },
      {
        content: 'Die Frau bekommt ein Kind und ihr Chef weiß das.',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '105',
    question: 'Was ist eine Aufgabe von Wahlhelfern / Wahlhelferinnen in Deutschland?',
    answers: [
      {
        content: 'Sie helfen alten Menschen bei der Stimmabgabe in der Wahlkabine.',
        key: 0,
      },
      {
        content: 'Sie schreiben die Wahlbenachrichtigungen vor der Wahl.',
        key: 0,
      },
      {
        content: 'Sie geben Zwischenergebnisse an die Medien weiter.',
        key: 0,
      },
      {
        content: 'Sie zählen die Stimmen nach dem Ende der Wahl.',
        key: 1,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '106',
    question:
      'In Deutschland helfen ehrenamtliche Wahlhelfer und Wahlhelferinnen bei den Wahlen. Was ist eine Aufgabe von Wahlhelfern / Wahlhelferinnen?',
    answers: [
      {
        content: 'Sie helfen Kindern und alten Menschen beim Wählen.',
        key: 0,
      },
      {
        content: 'Sie schreiben Karten und Briefe mit der Angabe des Wahllokals.',
        key: 0,
      },
      {
        content: 'Sie geben Zwischenergebnisse an Journalisten weiter.',
        key: 0,
      },
      {
        content: 'Sie zählen die Stimmen nach dem Ende der Wahl.',
        key: 1,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '107',
    question: 'Für wie viele Jahre wird der Bundestag in Deutschland gewählt?',
    answers: [
      {
        content: '2 Jahre',
        key: 0,
      },
      {
        content: '4 Jahre',
        key: 1,
      },
      {
        content: '6 Jahre',
        key: 0,
      },
      {
        content: '8 Jahre',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '108',
    question: 'Bei einer Bundestagswahl in Deutschland darf jeder wählen, der...',
    answers: [
      {
        content: 'in der Bundesrepublik Deutschland wohnt und wählen möchte.',
        key: 0,
      },
      {
        content: 'Bürger / Bürgerin der Bundesrepublik Deutschland ist und mindestens 18 Jahre alt ist.',
        key: 1,
      },
      {
        content: 'seit mindestens 3 Jahren in der Bundesrepublik Deutschland lebt.',
        key: 0,
      },
      {
        content: 'Bürger / Bürgerin der Bundesrepublik Deutschland ist und mindestens 21 Jahre alt ist.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '109',
    question: 'Wie oft gibt es normalerweise Bundestagswahlen in Deutschland?',
    answers: [
      {
        content: 'alle drei Jahre',
        key: 0,
      },
      {
        content: 'alle vier Jahre',
        key: 1,
      },
      {
        content: 'alle fünf Jahre',
        key: 0,
      },
      {
        content: 'alle sechs Jahre',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '110',
    question: 'Für wie viele Jahre wird der Bundestag in Deutschland gewählt?',
    answers: [
      {
        content: '2 Jahre',
        key: 0,
      },
      {
        content: '3 Jahre',
        key: 0,
      },
      {
        content: '4 Jahre',
        key: 1,
      },
      {
        content: '5 Jahre',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '111',
    question: 'In Deutschland darf man wählen. Was bedeutet das?',
    answers: [
      {
        content: 'Alle deutschen Staatsangehörigen dürfen wählen, wenn sie das Mindestalter erreicht haben.',
        key: 1,
      },
      {
        content: 'Nur verheiratete Personen dürfen wählen.',
        key: 0,
      },
      {
        content: 'Nur Personen mit einem festen Arbeitsplatz dürfen wählen.',
        key: 0,
      },
      {
        content: 'Alle Einwohner und Einwohnerinnen in Deutschland müssen wählen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '112',
    question: 'Die Wahlen in Deutschland sind...',
    answers: [
      {
        content: 'speziell.',
        key: 0,
      },
      {
        content: 'geheim.',
        key: 1,
      },
      {
        content: 'berufsbezogen.',
        key: 0,
      },
      {
        content: 'geschlechtsabhängig.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '113',
    question: 'Wahlen in Deutschland gewinnt die Partei, die...',
    answers: [
      {
        content: 'die meisten Stimmen bekommt.',
        key: 1,
      },
      {
        content: 'die meisten Männer mehrheitlich gewählt haben.',
        key: 0,
      },
      {
        content: 'die meisten Stimmen bei den Arbeitern / Arbeiterinnen bekommen hat.',
        key: 0,
      },
      {
        content: 'die meisten Erststimmen für ihren Kanzlerkandidaten / ihre Kanzlerkandidatin erhalten hat.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '114',
    question: 'An demokratischen Wahlen in Deutschland teilzunehmen ist...',
    answers: [
      {
        content: 'eine Pflicht.',
        key: 0,
      },
      {
        content: 'ein Recht.',
        key: 1,
      },
      {
        content: 'ein Zwang.',
        key: 0,
      },
      {
        content: 'eine Last.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '115',
    question: 'Was bedeutet \u201eaktives Wahlrecht\u201c in Deutschland?',
    answers: [
      {
        content: 'Man kann gewählt werden.',
        key: 0,
      },
      {
        content: 'Man muss wählen gehen.',
        key: 0,
      },
      {
        content: 'Man kann wählen.',
        key: 1,
      },
      {
        content: 'Man muss zur Auszählung der Stimmen gehen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '116',
    question: 'Wenn Sie bei einer Bundestagswahl in Deutschland wählen dürfen, heißt das...',
    answers: [
      {
        content: 'aktive Wahlkampagne.',
        key: 0,
      },
      {
        content: 'aktives Wahlverfahren.',
        key: 0,
      },
      {
        content: 'aktiver Wahlkampf.',
        key: 0,
      },
      {
        content: 'aktives Wahlrecht.',
        key: 1,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '117',
    question:
      'Wie viel Prozent der Zweitstimmen müssen Parteien mindestens bekommen, um in den Deutschen Bundestag gewählt zu werden?',
    answers: [
      {
        content: '3 %',
        key: 0,
      },
      {
        content: '4 %',
        key: 0,
      },
      {
        content: '5 %',
        key: 1,
      },
      {
        content: '6 %',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '118',
    question: 'Was regelt das Wahlrecht in Deutschland?',
    answers: [
      {
        content: 'Wer wählen darf, muss wählen.',
        key: 0,
      },
      {
        content: 'Alle die wollen, können wählen.',
        key: 0,
      },
      {
        content: 'Wer nicht wählt, verliert das Recht zu wählen.',
        key: 0,
      },
      {
        content: 'Wer wählen darf, kann wählen.',
        key: 1,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '119',
    question: 'Wahlen in Deutschland sind frei. Was bedeutet das?',
    answers: [
      {
        content: 'Alle verurteilten Straftäter / Straftäterinnen dürfen nicht wählen.',
        key: 0,
      },
      {
        content: 'Wenn ich wählen gehen möchte, muss mein Arbeitgeber / meine Arbeitgeberin mir frei geben.',
        key: 0,
      },
      {
        content: 'Jede Person kann ohne Zwang entscheiden, ob sie wählen möchte und wen sie wählen möchte.',
        key: 1,
      },
      {
        content: 'Ich kann frei entscheiden, wo ich wählen gehen möchte.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '120',
    question: 'Das Wahlsystem in Deutschland ist ein...',
    answers: [
      {
        content: 'Zensuswahlrecht.',
        key: 0,
      },
      {
        content: 'Dreiklassenwahlrecht.',
        key: 0,
      },
      {
        content: 'Mehrheits- und Verhältniswahlrecht.',
        key: 1,
      },
      {
        content: 'allgemeines Männerwahlrecht.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '121',
    question:
      'Eine Partei möchte in den Deutschen Bundestag. Sie muss aber einen Mindestanteil an Wählerstimmen haben. Das heißt...',
    answers: [
      {
        content: '5 %-Hürde.',
        key: 1,
      },
      {
        content: 'Zulassungsgrenze.',
        key: 0,
      },
      {
        content: 'Basiswert.',
        key: 0,
      },
      {
        content: 'Richtlinie.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '122',
    question: 'Welchem Grundsatz unterliegen Wahlen in Deutschland? Wahlen in Deutschland sind...',
    answers: [
      {
        content: 'frei, gleich, geheim.',
        key: 1,
      },
      {
        content: 'offen, sicher, frei.',
        key: 0,
      },
      {
        content: 'geschlossen, gleich, sicher.',
        key: 0,
      },
      {
        content: 'sicher, offen, freiwillig.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '123',
    question: 'Was ist in Deutschland die \u201e5 %-Hürde\u201c?',
    answers: [
      {
        content: 'Abstimmungsregelung im Bundestag für kleine Parteien',
        key: 0,
      },
      {
        content: 'Anwesenheitskontrolle im Bundestag für Abstimmungen',
        key: 0,
      },
      {
        content: 'Mindestanteil an Wählerstimmen, um ins Parlament zu kommen',
        key: 1,
      },
      {
        content: 'Anwesenheitskontrolle im Bundesrat für Abstimmungen',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '124',
    question: 'Die Bundestagswahl in Deutschland ist die Wahl...',
    answers: [
      {
        content: 'des Bundeskanzlers / der Bundeskanzlerin.',
        key: 0,
      },
      {
        content: 'der Parlamente der Länder.',
        key: 0,
      },
      {
        content: 'des Parlaments für Deutschland.',
        key: 1,
      },
      {
        content: 'des Bundespräsidenten / der Bundespräsidentin.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '125',
    question: 'In einer Demokratie ist eine Funktion von regelmäßigen Wahlen, ...',
    answers: [
      {
        content: 'die Bürger und Bürgerinnen zu zwingen, ihre Stimme abzugeben.',
        key: 0,
      },
      {
        content: 'nach dem Willen der Wählermehrheit den Wechsel der Regierung zu ermöglichen.',
        key: 1,
      },
      {
        content: 'im Land bestehende Gesetze beizubehalten.',
        key: 0,
      },
      {
        content: 'en Armen mehr Macht zu geben.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '126',
    question: 'Was bekommen wahlberechtigte Bürger und Bürgerinnen in Deutschland vor einer Wahl?',
    answers: [
      {
        content: 'eine Wahlbenachrichtigung von der Gemeinde',
        key: 1,
      },
      {
        content: 'eine Wahlerlaubnis vom Bundespräsidenten / von der Bundespräsidentin',
        key: 0,
      },
      {
        content: 'eine Benachrichtigung von der Bundesversammlung',
        key: 0,
      },
      {
        content: 'eine Benachrichtigung vom Pfarramt',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '127',
    question: 'Warum gibt es die 5 %-Hürde im Wahlgesetz der Bundesrepublik Deutschland? Es gibt sie, weil...',
    answers: [
      {
        content: 'die Programme von vielen kleinen Parteien viele Gemeinsamkeiten haben.',
        key: 0,
      },
      {
        content: 'die Bürger und Bürgerinnen bei vielen kleinen Parteien die Orientierung verlieren können.',
        key: 0,
      },
      {
        content: 'viele kleine Parteien die Regierungsbildung erschweren.',
        key: 1,
      },
      {
        content: 'die kleinen Parteien nicht so viel Geld haben, um die Politiker und Politikerinnen zu bezahlen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '128',
    question: 'Parlamentsmitglieder, die von den Bürgern und Bürgerinnen gewählt werden, nennt man...',
    answers: [
      {
        content: 'Abgeordnete.',
        key: 1,
      },
      {
        content: 'Kanzler / Kanzlerinnen.',
        key: 0,
      },
      {
        content: 'Botschafter / Botschafterinnen.',
        key: 0,
      },
      {
        content: 'Ministerpräsidenten / Ministerpräsidentinnen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '129',
    question: 'Vom Volk gewählt wird in Deutschland...',
    answers: [
      {
        content: 'der Bundeskanzler / die Bundeskanzlerin.',
        key: 0,
      },
      {
        content: 'der Ministerpräsident / die Ministerpräsidentin eines Bundeslandes.',
        key: 0,
      },
      {
        content: 'der Bundestag.',
        key: 1,
      },
      {
        content: 'der Bundespräsident / die Bundespräsidentin.',
        key: 0,
      },
    ],
    category: 'Verfassungsorgane',
  },
  {
    id: '130',
    question: 'Welcher Stimmzettel wäre bei einer Bundestagswahl gültig?',
    image: '130',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Wahlen',
  },
  {
    id: '131',
    question: 'In Deutschland ist ein Bürgermeister / eine Bürgermeisterin...',
    answers: [
      {
        content: 'der Leiter / die Leiterin einer Schule.',
        key: 0,
      },
      {
        content: 'der Chef / die Chefin einer Bank.',
        key: 0,
      },
      {
        content: 'das Oberhaupt einer Gemeinde.',
        key: 1,
      },
      {
        content: 'der / die Vorsitzende einer Partei.',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '132',
    question: 'Viele Menschen in Deutschland arbeiten in ihrer Freizeit ehrenamtlich. Was bedeutet das?',
    answers: [
      {
        content: 'Sie arbeiten als Soldaten / Soldatinnen.',
        key: 0,
      },
      {
        content: 'Sie arbeiten freiwillig und unbezahlt in Vereinen und Verbänden.',
        key: 1,
      },
      {
        content: 'Sie arbeiten in der Bundesregierung.',
        key: 0,
      },
      {
        content: 'Sie arbeiten in einem Krankenhaus und verdienen dabei Geld.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '133',
    question: 'Was ist bei Bundestags- und Landtagswahlen in Deutschland erlaubt?',
    answers: [
      {
        content: 'Der Ehemann wählt für seine Frau mit.',
        key: 0,
      },
      {
        content: 'Man kann durch Briefwahl seine Stimme abgeben.',
        key: 1,
      },
      {
        content: 'Man kann am Wahltag telefonisch seine Stimme abgeben.',
        key: 0,
      },
      {
        content: 'Kinder ab dem Alter von 14 Jahren dürfen wählen.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '134',
    question:
      'Man will die Buslinie abschaffen, mit der Sie immer zur Arbeit fahren. Was können Sie machen, um die Buslinie zu erhalten?',
    answers: [
      {
        content:
          'Ich beteilige mich an einer Bürgerinitiative für die Erhaltung der Buslinie oder gründe selber eine Initiative.',
        key: 1,
      },
      {
        content: 'Ich werde Mitglied in einem Sportverein und trainiere Rad fahren.',
        key: 0,
      },
      {
        content: 'Ich wende mich an das Finanzamt, weil ich als Steuerzahler / Steuerzahlerin ein Recht auf die Buslinie habe.',
        key: 0,
      },
      {
        content: 'Ich schreibe einen Brief an das Forstamt der Gemeinde.',
        key: 0,
      },
    ],
    category: 'Wahlen und Beteiligung',
  },
  {
    id: '135',
    question: 'Wen vertreten die Gewerkschaften in Deutschland?',
    answers: [
      {
        content: 'große Unternehmen',
        key: 0,
      },
      {
        content: 'kleine Unternehmen',
        key: 0,
      },
      {
        content: 'Selbstständige',
        key: 0,
      },
      {
        content: 'Arbeitnehmer und Arbeitnehmerinnen',
        key: 1,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '136',
    question: 'Sie gehen in Deutschland zum Arbeitsgericht bei...',
    answers: [
      {
        content: 'falscher Nebenkostenabrechnung.',
        key: 0,
      },
      {
        content: 'ungerechtfertigter Kündigung durch Ihren Chef / Ihre Chefin.',
        key: 1,
      },
      {
        content: 'Problemen mit den Nachbarn / Nachbarinnen.',
        key: 0,
      },
      {
        content: 'Schwierigkeiten nach einem Verkehrsunfall.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '137',
    question: 'Welches Gericht ist in Deutschland bei Konflikten in der Arbeitswelt zuständig?',
    answers: [
      {
        content: 'das Familiengericht',
        key: 0,
      },
      {
        content: 'das Strafgericht',
        key: 0,
      },
      {
        content: 'das Arbeitsgericht',
        key: 1,
      },
      {
        content: 'das Amtsgericht',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '138',
    question: 'Was kann ich in Deutschland machen, wenn mir mein Arbeitgeber / meine Arbeitgeberin zu Unrecht gekündigt hat?',
    answers: [
      {
        content: 'weiter arbeiten und freundlich zum Chef / zur Chefin sein',
        key: 0,
      },
      {
        content: 'ein Mahnverfahren gegen den Arbeitgeber / die Arbeitgeberin führen',
        key: 0,
      },
      {
        content: 'Kündigungsschutzklage erheben',
        key: 1,
      },
      {
        content: 'den Arbeitgeber / die Arbeitgeberin bei der Polizei anzeigen',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '139',
    question: 'Wann kommt es in Deutschland zu einem Prozess vor Gericht? Wenn jemand...',
    answers: [
      {
        content: 'zu einer anderen Religion übertritt.',
        key: 0,
      },
      {
        content: 'eine Straftat begangen hat und angeklagt wird.',
        key: 1,
      },
      {
        content: 'eine andere Meinung als die der Regierung vertritt.',
        key: 0,
      },
      {
        content: 'sein Auto falsch geparkt hat und es abgeschleppt wird.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '140',
    question: 'Was macht ein Schöffe / eine Schöffin in Deutschland? Er / Sie...',
    answers: [
      {
        content: 'entscheidet mit Richtern / Richterinnen über Schuld und Strafe.',
        key: 1,
      },
      {
        content: 'gibt Bürgern / Bürgerinnen rechtlichen Rat.',
        key: 0,
      },
      {
        content: 'stellt Urkunden aus.',
        key: 0,
      },
      {
        content: 'verteidigt den Angeklagten / die Angeklagte.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '141',
    question: 'Wer berät in Deutschland Personen bei Rechtsfragen und vertritt sie vor Gericht?',
    answers: [
      {
        content: 'ein Rechtsanwalt / eine Rechtsanwältin',
        key: 1,
      },
      {
        content: 'ein Richter / eine Richterin',
        key: 0,
      },
      {
        content: 'ein Schöffe / eine Schöffin',
        key: 0,
      },
      {
        content: 'ein Staatsanwalt / eine Staatsanwältin',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '142',
    question: 'Was ist die Hauptaufgabe eines Richters / einer Richterin in Deutschland? Ein Richter / eine Richterin...',
    answers: [
      {
        content: 'vertritt Bürger und Bürgerinnen vor einem Gericht.',
        key: 0,
      },
      {
        content: 'arbeitet an einem Gericht und spricht Urteile.',
        key: 1,
      },
      {
        content: 'ändert Gesetze.',
        key: 0,
      },
      {
        content: 'betreut Jugendliche vor Gericht.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '143',
    question: 'Ein Richter / eine Richterin in Deutschland gehört zur ...',
    answers: [
      {
        content: 'Judikative.',
        key: 1,
      },
      {
        content: 'Exekutive.',
        key: 0,
      },
      {
        content: 'Operative.',
        key: 0,
      },
      {
        content: 'Legislative.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '144',
    question: 'Ein Richter / eine Richterin gehört in Deutschland zur...',
    answers: [
      {
        content: 'vollziehenden Gewalt.',
        key: 0,
      },
      {
        content: 'rechtsprechenden Gewalt.',
        key: 1,
      },
      {
        content: 'planenden Gewalt.',
        key: 0,
      },
      {
        content: 'gesetzgebenden Gewalt.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '145',
    question:
      'In Deutschland wird die Staatsgewalt geteilt. Für welche Staatsgewalt arbeitet ein Richter / eine Richterin? Für die...',
    answers: [
      {
        content: 'Judikative.',
        key: 1,
      },
      {
        content: 'Exekutive.',
        key: 0,
      },
      {
        content: 'Presse.',
        key: 0,
      },
      {
        content: 'Legislative.',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '146',
    question: 'Wie nennt man in Deutschland ein Verfahren vor einem Gericht?',
    answers: [
      {
        content: 'Programm',
        key: 0,
      },
      {
        content: 'Prozedur',
        key: 0,
      },
      {
        content: 'Protokoll',
        key: 0,
      },
      {
        content: 'Prozess',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '147',
    question: 'Was ist die Arbeit eines Richters / einer Richterin in Deutschland?',
    answers: [
      {
        content: 'Deutschland regieren',
        key: 0,
      },
      {
        content: 'Recht sprechen',
        key: 1,
      },
      {
        content: 'Pläne erstellen',
        key: 0,
      },
      {
        content: 'Gesetze erlassen',
        key: 0,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '148',
    question: 'Was ist eine Aufgabe der Polizei in Deutschland?',
    answers: [
      {
        content: 'das Land zu verteidigen',
        key: 0,
      },
      {
        content: 'die Bürgerinnen und Bürger abzuhören',
        key: 0,
      },
      {
        content: 'die Gesetze zu beschließen',
        key: 0,
      },
      {
        content: 'die Einhaltung von Gesetzen zu überwachen',
        key: 1,
      },
    ],
    category: 'Verfassungsprinzipien',
  },
  {
    id: '149',
    question: 'Wer kann Gerichtsschöffe / Gerichtsschöffin in Deutschland werden?',
    answers: [
      {
        content: 'alle in Deutschland geborenen Einwohner / Einwohnerinnen über 18 Jahre',
        key: 0,
      },
      {
        content: 'alle deutschen Staatsangehörigen älter als 24 und jünger als 70 Jahre',
        key: 1,
      },
      {
        content: 'alle Personen, die seit mindestens 5 Jahren in Deutschland leben',
        key: 0,
      },
      {
        content: 'nur Personen mit einem abgeschlossenen Jurastudium',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '150',
    question: 'Ein Gerichtsschöffe / eine Gerichtsschöffin in Deutschland ist...',
    answers: [
      {
        content: 'der Stellvertreter / die Stellvertreterin des Stadtoberhaupts.',
        key: 0,
      },
      {
        content: 'ein ehrenamtlicher Richter / eine ehrenamtliche Richterin.',
        key: 1,
      },
      {
        content: 'ein Mitglied eines Gemeinderats.',
        key: 0,
      },
      {
        content: 'eine Person, die Jura studiert hat.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '151',
    question: 'Wer baute die Mauer in Berlin?',
    answers: [
      {
        content: 'Großbritannien',
        key: 0,
      },
      {
        content: 'die Bundesrepublik Deutschland',
        key: 0,
      },
      {
        content: 'die DDR',
        key: 1,
      },
      {
        content: 'die USA',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '152',
    question: 'Wann waren die Nationalsozialisten mit Adolf Hitler in Deutschland an der Macht?',
    answers: [
      {
        content: '1918 bis 1923',
        key: 0,
      },
      {
        content: '1932 bis 1950',
        key: 0,
      },
      {
        content: '1933 bis 1945',
        key: 1,
      },
      {
        content: '1945 bis 1989',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '153',
    question: 'Was war am 8. Mai 1945?',
    answers: [
      {
        content: 'Tod Adolf Hitlers',
        key: 0,
      },
      {
        content: 'Beginn des Berliner Mauerbaus',
        key: 0,
      },
      {
        content: 'Wahl von Konrad Adenauer zum Bundeskanzler',
        key: 0,
      },
      {
        content: 'Ende des Zweiten Weltkriegs in Europa',
        key: 1,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '154',
    question: 'Wann war der Zweite Weltkrieg zu Ende?',
    answers: [
      {
        content: '1933',
        key: 0,
      },
      {
        content: '1945',
        key: 1,
      },
      {
        content: '1949',
        key: 0,
      },
      {
        content: '1961',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '155',
    question: 'Wann waren die Nationalsozialisten in Deutschland an der Macht?',
    answers: [
      {
        content: '1888 bis 1918',
        key: 0,
      },
      {
        content: '1921 bis 1934',
        key: 0,
      },
      {
        content: '1933 bis 1945',
        key: 1,
      },
      {
        content: '1949 bis 1963',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '156',
    question: 'In welchem Jahr wurde Hitler Reichskanzler?',
    answers: [
      {
        content: '1923',
        key: 0,
      },
      {
        content: '1927',
        key: 0,
      },
      {
        content: '1933',
        key: 1,
      },
      {
        content: '1936',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '157',
    question: 'Die Nationalsozialisten mit Adolf Hitler errichteten 1933 in Deutschland ...',
    answers: [
      {
        content: 'eine Diktatur.',
        key: 1,
      },
      {
        content: 'einen demokratischen Staat.',
        key: 0,
      },
      {
        content: 'eine Monarchie.',
        key: 0,
      },
      {
        content: 'ein Fürstentum.',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '158',
    question: 'Das \u201eDritte Reich\u201c war eine ...',
    answers: [
      {
        content: 'Diktatur.',
        key: 1,
      },
      {
        content: 'Demokratie.',
        key: 0,
      },
      {
        content: 'Monarchie.',
        key: 0,
      },
      {
        content: 'Räterepublik.',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '159',
    question: 'Was gab es in Deutschland nicht während der Zeit des Nationalsozialismus?',
    answers: [
      {
        content: 'freie Wahlen',
        key: 1,
      },
      {
        content: 'Pressezensur',
        key: 0,
      },
      {
        content: 'willkürliche Verhaftungen',
        key: 0,
      },
      {
        content: 'Verfolgung der Juden',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '160',
    question: 'Welcher Krieg dauerte von 1939 bis 1945?',
    answers: [
      {
        content: 'der Erste Weltkrieg',
        key: 0,
      },
      {
        content: 'der Zweite Weltkrieg',
        key: 1,
      },
      {
        content: 'der Vietnamkrieg',
        key: 0,
      },
      {
        content: 'der Golfkrieg',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '161',
    question: 'Was kennzeichnete den NS-Staat? Eine Politik ...',
    answers: [
      {
        content: 'des staatlichen Rassismus',
        key: 1,
      },
      {
        content: 'der Meinungsfreiheit',
        key: 0,
      },
      {
        content: 'der allgemeinen Religionsfreiheit',
        key: 0,
      },
      {
        content: 'der Entwicklung der Demokratie',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '162',
    question: 'Claus Schenk Graf von Stauffenberg wurde bekannt durch ...',
    answers: [
      {
        content: 'eine Goldmedaille bei den Olympischen Spielen 1936.',
        key: 0,
      },
      {
        content: 'den Bau des Reichstagsgebäudes.',
        key: 0,
      },
      {
        content: 'den Aufbau der Wehrmacht.',
        key: 0,
      },
      {
        content: 'das Attentat auf Hitler am 20. Juli 1944.',
        key: 1,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '163',
    question: 'In welchem Jahr zerstörten die Nationalsozialisten Synagogen und jüdische Geschäfte in Deutschland?',
    answers: [
      {
        content: '1925',
        key: 0,
      },
      {
        content: '1930',
        key: 0,
      },
      {
        content: '1938',
        key: 1,
      },
      {
        content: '1945',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '164',
    question: 'Was passierte am 9. November 1938 in Deutschland?',
    answers: [
      {
        content: 'Mit dem Angriff auf Polen beginnt der Zweite Weltkrieg.',
        key: 0,
      },
      {
        content: 'Die Nationalsozialisten verlieren eine Wahl und lösen den Reichstag auf.',
        key: 0,
      },
      {
        content: 'Jüdische Geschäfte und Synagogen werden durch Nationalsozialisten und ihre Anhänger zerstört. ',
        key: 1,
      },
      {
        content: 'Hitler wird Reichspräsident und lässt alle Parteien verbieten.',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '165',
    question: 'Wie hieß der erste Bundeskanzler der Bundesrepublik Deutschland?',
    answers: [
      {
        content: 'Konrad Adenauer',
        key: 1,
      },
      {
        content: 'Kurt Georg Kiesinger',
        key: 0,
      },
      {
        content: 'Helmut Schmidt',
        key: 0,
      },
      {
        content: 'Willy Brandt',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '166',
    question: 'Bei welchen Demonstrationen in Deutschland riefen die Menschen \u201eWir sind das Volk\u201c?',
    answers: [
      {
        content: 'bei den Montagsdemonstrationen 1989 in der DDR',
        key: 1,
      },
      {
        content: 'beim Arbeiteraufstand 1953 in der DDR',
        key: 0,
      },
      {
        content: 'bei den Demonstrationen 1968 in der Bundesrepublik Deutschland',
        key: 0,
      },
      {
        content: 'bei den Anti-Atomkraft-Demonstrationen 1985 in der Bundesrepublik Deutschland',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '167',
    question:
      'Welche Länder wurden nach dem Zweiten Weltkrieg in Deutschland als \u201eAlliierte Besatzungsmächte\u201c bezeichnet?',
    answers: [
      {
        content: 'Sowjetunion, Großbritannien, Polen, Schweden',
        key: 0,
      },
      {
        content: 'Frankreich, Sowjetunion, Italien, Japan',
        key: 0,
      },
      {
        content: 'USA, Sowjetunion, Spanien, Portugal',
        key: 0,
      },
      {
        content: 'USA, Sowjetunion, Großbritannien, Frankreich',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '168',
    question: 'Welches Land war keine \u201eAlliierte Besatzungsmacht\u201c in Deutschland?',
    answers: [
      {
        content: 'USA',
        key: 0,
      },
      {
        content: 'Sowjetunion',
        key: 0,
      },
      {
        content: 'Frankreich',
        key: 0,
      },
      {
        content: 'Japan',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '169',
    question: 'Wann wurde die Bundesrepublik Deutschland gegründet?',
    answers: [
      {
        content: '1939',
        key: 0,
      },
      {
        content: '1945',
        key: 0,
      },
      {
        content: '1949',
        key: 1,
      },
      {
        content: '1951',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '170',
    question: 'Was gab es während der Zeit des Nationalsozialismus in Deutschland?',
    answers: [
      {
        content: 'das Recht zur freien Entfaltung der Persönlichkeit',
        key: 0,
      },
      {
        content: 'Pressefreiheit',
        key: 0,
      },
      {
        content: 'das Verbot von Parteien',
        key: 1,
      },
      {
        content: 'den Schutz der Menschenwürde',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '171',
    question: 'Soziale Marktwirtschaft bedeutet, die Wirtschaft ...',
    answers: [
      {
        content: 'steuert sich allein nach Angebot und Nachfrage.',
        key: 0,
      },
      {
        content: 'wird vom Staat geplant und gesteuert, Angebot und Nachfrage werden nicht berücksichtigt.',
        key: 0,
      },
      {
        content: 'richtet sich nach der Nachfrage im Ausland.',
        key: 0,
      },
      {
        content: 'richtet sich nach Angebot und Nachfrage, aber der Staat sorgt für einen sozialen Ausgleich.',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '172',
    question: 'In welcher Besatzungszone wurde die DDR gegründet? In der ...',
    answers: [
      {
        content: 'amerikanischen Besatzungszone.',
        key: 0,
      },
      {
        content: 'französischen Besatzungszone.',
        key: 0,
      },
      {
        content: 'britischen Besatzungszone.',
        key: 0,
      },
      {
        content: 'sowjetischen Besatzungszone.',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '173',
    question: 'Die Bundesrepublik Deutschland ist ein Gründungsmitglied ...',
    answers: [
      {
        content: 'des Nordatlantikpakts (NATO).',
        key: 0,
      },
      {
        content: 'der Vereinten Nationen (VN).',
        key: 0,
      },
      {
        content: 'der Europäischen Union (EU).',
        key: 1,
      },
      {
        content: 'des Warschauer Pakts.',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '174',
    question: 'Wann wurde die DDR gegründet?',
    answers: [
      {
        content: '1947',
        key: 0,
      },
      {
        content: '1949',
        key: 1,
      },
      {
        content: '1953',
        key: 0,
      },
      {
        content: '1956',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '175',
    question: 'Wie viele Besatzungszonen gab es in Deutschland nach dem Zweiten Weltkrieg?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
      {
        content: '5',
        key: 0,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '176',
    question: 'Wie waren die Besatzungszonen Deutschlands nach 1945 verteilt?',
    image: '176',
    answers: [
      {
        content: '1=Großbritannien, 2=Sowjetunion, 3=Frankreich, 4=USA',
        key: 0,
      },
      {
        content: '1=Sowjetunion, 2=Großbritannien, 3=USA, 4=Frankreich',
        key: 0,
      },
      {
        content: '1=Großbritannien, 2=Sowjetunion, 3=USA, 4=Frankreich',
        key: 1,
      },
      {
        content: '1=Großbritannien, 2=USA, 3=Sowjetunion, 4=Frankreich',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '177',
    question: 'Welche deutsche Stadt wurde nach dem Zweiten Weltkrieg in vier Sektoren aufgeteilt?',
    answers: [
      {
        content: 'München',
        key: 0,
      },
      {
        content: 'Berlin',
        key: 1,
      },
      {
        content: 'Dresden',
        key: 0,
      },
      {
        content: 'Frankfurt (Oder)',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '178',
    question:
      'Vom Juni 1948 bis zum Mai 1949 wurden die Bürger und Bürgerinnen von West-Berlin durch eine Luftbrücke versorgt. Welcher Umstand war dafür verantwortlich?',
    answers: [
      {
        content: 'Für Frankreich war eine Versorgung der West-Berliner Bevölkerung mit dem Flugzeug kostengünstiger.',
        key: 0,
      },
      {
        content: 'Die amerikanischen Soldaten / Soldatinnen hatten beim Landtransport Angst vor Überfällen.',
        key: 0,
      },
      {
        content: 'Für Großbritannien war die Versorgung über die Luftbrücke schneller.',
        key: 0,
      },
      {
        content: 'Die Sowjetunion unterbrach den gesamten Verkehr auf dem Landwege. ',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '179',
    question: 'Wie endete der Zweite Weltkrieg in Europa offiziell?',
    answers: [
      {
        content: 'mit dem Tod Adolf Hitlers',
        key: 0,
      },
      {
        content: 'durch die bedingungslose Kapitulation Deutschlands',
        key: 1,
      },
      {
        content: 'mit dem Rückzug der Deutschen aus den besetzten Gebieten',
        key: 0,
      },
      {
        content: 'durch eine Revolution in Deutschland',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '180',
    question: 'Der erste Bundeskanzler der Bundesrepublik Deutschland war ...',
    answers: [
      {
        content: 'Ludwig Erhard.',
        key: 0,
      },
      {
        content: 'Willy Brandt.',
        key: 0,
      },
      {
        content: 'Konrad Adenauer.',
        key: 1,
      },
      {
        content: 'Gerhard Schröder.',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '181',
    question: 'Was wollte Willy Brandt mit seinem Kniefall 1970 im ehemaligen jüdischen Ghetto in Warschau ausdrücken?',
    image: '181',
    answers: [
      {
        content: 'Er hat sich den ehemaligen Alliierten unterworfen.',
        key: 0,
      },
      {
        content: 'Er bat Polen und die polnischen Juden um Vergebung.',
        key: 1,
      },
      {
        content: 'Er zeigte seine Demut vor dem Warschauer Pakt.',
        key: 0,
      },
      {
        content: 'Er sprach ein Gebet am Grab des Unbekannten Soldaten.',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '182',
    question: 'Welche Parteien wurden 1946 zwangsweise zur SED vereint, der Einheitspartei der späteren DDR?',
    answers: [
      {
        content: 'KPD und SPD',
        key: 1,
      },
      {
        content: 'SPD und CDU',
        key: 0,
      },
      {
        content: 'CDU und FDP',
        key: 0,
      },
      {
        content: 'KPD und CSU',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '183',
    question: 'Wann war in der Bundesrepublik Deutschland das \u201eWirtschaftswunder\u201c?',
    answers: [
      {
        content: '40er Jahre',
        key: 0,
      },
      {
        content: '50er Jahre',
        key: 1,
      },
      {
        content: '70er Jahre',
        key: 0,
      },
      {
        content: '80er Jahre',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '184',
    question: 'Was nannten die Menschen in Deutschland sehr lange \u201eDie Stunde Null\u201c?',
    answers: [
      {
        content: 'Damit wird die Zeit nach der Wende im Jahr 1989 bezeichnet.',
        key: 0,
      },
      {
        content: 'Damit wurde der Beginn des Zweiten Weltkrieges bezeichnet.',
        key: 0,
      },
      {
        content: 'Darunter verstand man das Ende des Zweiten Weltkrieges und den Beginn des Wiederaufbaus. ',
        key: 1,
      },
      {
        content: 'Damit ist die Stunde gemeint, in der die Uhr von der Sommerzeit auf die Winterzeit umgestellt wird.',
        key: 0,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '185',
    question: 'Wofür stand der Ausdruck \u201eEiserner Vorhang\u201c? Für die Abschottung ...',
    answers: [
      {
        content: 'des Warschauer Pakts gegen den Westen.',
        key: 1,
      },
      {
        content: 'Norddeutschlands gegen Süddeutschland.',
        key: 0,
      },
      {
        content: 'Nazi-Deutschlands gegen die Alliierten.',
        key: 0,
      },
      {
        content: 'Europas gegen die USA.',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '186',
    question:
      'Im Jahr 1953 gab es in der DDR einen Aufstand, an den lange Zeit in der Bundesrepublik Deutschland ein Feiertag erinnerte. Wann war das?',
    answers: [
      {
        content: '1. Mai',
        key: 0,
      },
      {
        content: '17. Juni',
        key: 1,
      },
      {
        content: '20. Juli',
        key: 0,
      },
      {
        content: '9. November',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '187',
    question: 'Welcher deutsche Staat hatte eine schwarz-rot-goldene Flagge mit Hammer, Zirkel und Ährenkranz?',
    image: '187',
    answers: [
      {
        content: 'Preußen',
        key: 0,
      },
      {
        content: 'Bundesrepublik Deutschland',
        key: 0,
      },
      {
        content: 'DDR',
        key: 1,
      },
      {
        content: '\u201eDrittes Reich\u201c',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '188',
    question: 'In welchem Jahr wurde die Mauer in Berlin gebaut?',
    answers: [
      {
        content: '1953',
        key: 0,
      },
      {
        content: '1956',
        key: 0,
      },
      {
        content: '1959',
        key: 0,
      },
      {
        content: '1961',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '189',
    question: 'Wann baute die DDR die Mauer in Berlin?',
    answers: [
      {
        content: '1919',
        key: 0,
      },
      {
        content: '1933',
        key: 0,
      },
      {
        content: '1961',
        key: 1,
      },
      {
        content: '1990',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '190',
    question: 'Was bedeutet die Abkürzung DDR?',
    answers: [
      {
        content: 'Dritter Deutscher Rundfunk',
        key: 0,
      },
      {
        content: 'Die Deutsche Republik',
        key: 0,
      },
      {
        content: 'Dritte Deutsche Republik',
        key: 0,
      },
      {
        content: 'Deutsche Demokratische Republik',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '191',
    question: 'Wann wurde die Mauer in Berlin für alle geöffnet?',
    answers: [
      {
        content: '1987',
        key: 0,
      },
      {
        content: '1989',
        key: 1,
      },
      {
        content: '1992',
        key: 0,
      },
      {
        content: '1995',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '192',
    question: 'Welches heutige deutsche Bundesland gehörte früher zum Gebiet der DDR?',
    answers: [
      {
        content: 'Brandenburg',
        key: 1,
      },
      {
        content: 'Bayern',
        key: 0,
      },
      {
        content: 'Saarland',
        key: 0,
      },
      {
        content: 'Hessen',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '193',
    question: 'Von 1961 bis 1989 war Berlin ...',
    answers: [
      {
        content: 'ohne Bürgermeister.',
        key: 0,
      },
      {
        content: 'ein eigener Staat.',
        key: 0,
      },
      {
        content: 'durch eine Mauer geteilt.',
        key: 1,
      },
      {
        content: 'nur mit dem Flugzeug erreichbar.',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '194',
    question: 'Am 3. Oktober feiert man in Deutschland den Tag der Deutschen ...',
    answers: [
      {
        content: 'Einheit.',
        key: 1,
      },
      {
        content: 'Nation.',
        key: 0,
      },
      {
        content: 'Bundesländer.',
        key: 0,
      },
      {
        content: 'Städte.',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '195',
    question: 'Welches heutige deutsche Bundesland gehörte früher zum Gebiet der DDR?',
    answers: [
      {
        content: 'Hessen',
        key: 0,
      },
      {
        content: 'Sachsen-Anhalt',
        key: 1,
      },
      {
        content: 'Nordrhein-Westfalen',
        key: 0,
      },
      {
        content: 'Saarland',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '196',
    question:
      'Warum nennt man die Zeit im Herbst 1989 in der DDR \u201eDie Wende\u201c? In dieser Zeit veränderte sich die DDR politisch ...',
    answers: [
      {
        content: 'von einer Diktatur zur Demokratie.',
        key: 1,
      },
      {
        content: 'von einer liberalen Marktwirtschaft zum Sozialismus.',
        key: 0,
      },
      {
        content: 'von einer Monarchie zur Sozialdemokratie.',
        key: 0,
      },
      {
        content: 'von einem religiösen Staat zu einem kommunistischen Staat.',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '197',
    question: 'Welches heutige deutsche Bundesland gehörte früher zum Gebiet der DDR?',
    answers: [
      {
        content: 'Thüringen',
        key: 1,
      },
      {
        content: 'Hessen',
        key: 0,
      },
      {
        content: 'Bayern',
        key: 0,
      },
      {
        content: 'Bremen',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '198',
    question: 'Welches heutige deutsche Bundesland gehörte früher zum Gebiet der DDR?',
    answers: [
      {
        content: 'Bayern',
        key: 0,
      },
      {
        content: 'Niedersachsen',
        key: 0,
      },
      {
        content: 'Sachsen',
        key: 1,
      },
      {
        content: 'Baden-Württemberg',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '199',
    question: 'Mit der Abkürzung \u201eStasi\u201c meinte man in der DDR ...',
    answers: [
      {
        content: 'das Parlament.',
        key: 0,
      },
      {
        content: 'das Ministerium für Staatssicherheit.',
        key: 1,
      },
      {
        content: 'eine regierende Partei.',
        key: 0,
      },
      {
        content: 'das Ministerium für Volksbildung.',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '200',
    question: 'Welches heutige deutsche Bundesland gehörte früher zum Gebiet der DDR?',
    answers: [
      {
        content: 'Hessen',
        key: 0,
      },
      {
        content: 'Schleswig-Holstein',
        key: 0,
      },
      {
        content: 'Mecklenburg-Vorpommern',
        key: 1,
      },
      {
        content: 'Saarland',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '201',
    question: 'Welche der folgenden Auflistungen enthält nur Bundesländer, die zum Gebiet der früheren DDR gehörten?',
    answers: [
      {
        content: 'Niedersachsen, Nordrhein-Westfalen, Hessen, Schleswig-Holstein, Brandenburg',
        key: 0,
      },
      {
        content: 'Mecklenburg-Vorpommern, Brandenburg, Sachsen, Sachsen-Anhalt, Thüringen',
        key: 1,
      },
      {
        content: 'Bayern, Baden-Württemberg, Rheinland-Pfalz, Thüringen, Sachsen',
        key: 0,
      },
      {
        content: 'Sachsen, Thüringen, Hessen, Niedersachsen, Brandenburg',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '202',
    question: 'Zu wem gehörte die DDR im \u201eKalten Krieg\u201c?',
    answers: [
      {
        content: 'zu den Westmächten',
        key: 0,
      },
      {
        content: 'zum Warschauer Pakt',
        key: 1,
      },
      {
        content: 'zur NATO',
        key: 0,
      },
      {
        content: 'zu den blockfreien Staaten',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '203',
    question: 'Wie hieß das Wirtschaftssystem der DDR?',
    answers: [
      {
        content: 'Marktwirtschaft',
        key: 0,
      },
      {
        content: 'Planwirtschaft',
        key: 1,
      },
      {
        content: 'Angebot und Nachfrage',
        key: 0,
      },
      {
        content: 'Kapitalismus',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '204',
    question: 'Wie wurden die Bundesrepublik Deutschland und die DDR zu einem Staat?',
    answers: [
      {
        content: 'Die Bundesrepublik Deutschland hat die DDR besetzt.',
        key: 0,
      },
      {
        content: 'Die heutigen fünf östlichen Bundesländer sind der Bundesrepublik Deutschland beigetreten.',
        key: 1,
      },
      {
        content: 'Die westlichen Bundesländer sind der DDR beigetreten.',
        key: 0,
      },
      {
        content: 'Die DDR hat die Bundesrepublik Deutschland besetzt.',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '205',
    question: 'Mit dem Beitritt der DDR zur Bundesrepublik Deutschland gehören die neuen Bundesländer nun auch ...',
    answers: [
      {
        content: 'zur Europäischen Union.',
        key: 1,
      },
      {
        content: 'zum Warschauer Pakt.',
        key: 0,
      },
      {
        content: 'zur OPEC.',
        key: 0,
      },
      {
        content: 'zur Europäischen Verteidigungsgemeinschaft.',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '206',
    question: 'Was bedeutete im Jahr 1989 in Deutschland das Wort \u201eMontagsdemonstration\u201c?',
    answers: [
      {
        content: 'In der Bundesrepublik waren Demonstrationen nur am Montag erlaubt.',
        key: 0,
      },
      {
        content: 'Montags waren Demonstrationen gegen das DDR-Regime.',
        key: 1,
      },
      {
        content: 'Am ersten Montag im Monat trafen sich in der Bundesrepublik Deutschland Demonstranten.',
        key: 0,
      },
      {
        content: 'Montags demonstrierte man in der DDR gegen den Westen.',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '207',
    question: 'In welchem Militärbündnis war die DDR Mitglied?',
    answers: [
      {
        content: 'in der NATO',
        key: 0,
      },
      {
        content: 'im Rheinbund',
        key: 0,
      },
      {
        content: 'im Warschauer Pakt',
        key: 1,
      },
      {
        content: 'im Europabündnis',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '208',
    question: 'Was war die \u201eStasi\u201c?',
    answers: [
      {
        content: 'der Geheimdienst im \u201eDritten Reich\u201c',
        key: 0,
      },
      {
        content: 'eine berühmte deutsche Gedenkstätte',
        key: 0,
      },
      {
        content: 'der Geheimdienst der DDR',
        key: 1,
      },
      {
        content: 'ein deutscher Sportverein während des Zweiten Weltkrieges',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '209',
    question: 'Welches war das Wappen der Deutschen Demokratischen Republik?',
    image: '209',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '210',
    question: 'Was ereignete sich am 17. Juni 1953 in der DDR?',
    answers: [
      {
        content: 'der feierliche Beitritt zum Warschauer Pakt',
        key: 0,
      },
      {
        content: 'landesweite Streiks und ein Volksaufstand',
        key: 1,
      },
      {
        content: 'der 1. SED-Parteitag',
        key: 0,
      },
      {
        content: 'der erste Besuch Fidel Castros',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '211',
    question: 'Welcher Politiker steht für die \u201eOstverträge\u201c?',
    answers: [
      {
        content: 'Helmut Kohl',
        key: 0,
      },
      {
        content: 'Willy Brandt',
        key: 1,
      },
      {
        content: 'Michail Gorbatschow',
        key: 0,
      },
      {
        content: 'Ludwig Erhard',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '212',
    question: 'Wie heißt Deutschland mit vollem Namen?',
    answers: [
      {
        content: 'Bundesstaat Deutschland',
        key: 0,
      },
      {
        content: 'Bundesländer Deutschland',
        key: 0,
      },
      {
        content: 'Bundesrepublik Deutschland',
        key: 1,
      },
      {
        content: 'Bundesbezirk Deutschland',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '213',
    question: 'Wie viele Einwohner hat Deutschland?',
    answers: [
      {
        content: '70 Millionen',
        key: 0,
      },
      {
        content: '78 Millionen',
        key: 0,
      },
      {
        content: '80 Millionen',
        key: 1,
      },
      {
        content: '90 Millionen',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '214',
    question: 'Welche Farben hat die deutsche Flagge?',
    answers: [
      {
        content: 'schwarz-rot-gold',
        key: 1,
      },
      {
        content: 'rot-weiß-schwarz',
        key: 0,
      },
      {
        content: 'schwarz-rot-grün',
        key: 0,
      },
      {
        content: 'schwarz-gelb-rot',
        key: 0,
      },
    ],
    category: 'Staatssymbole',
  },
  {
    id: '215',
    question: 'Wer wird als \u201eKanzler der Deutschen Einheit\u201c bezeichnet?',
    answers: [
      {
        content: 'Gerhard Schröder',
        key: 0,
      },
      {
        content: 'Helmut Kohl',
        key: 1,
      },
      {
        content: 'Konrad Adenauer',
        key: 0,
      },
      {
        content: 'Helmut Schmidt',
        key: 0,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '216',
    question: 'Welches Symbol ist im Plenarsaal des Deutschen Bundestages zu sehen?',
    image: '216',
    answers: [
      {
        content: 'die Fahne der Stadt Berlin.',
        key: 0,
      },
      {
        content: 'der Bundesadler.',
        key: 1,
      },
      {
        content: 'der Reichsadler.',
        key: 0,
      },
      {
        content: 'die Reichskrone.',
        key: 0,
      },
    ],
    category: 'Staatssymbole',
  },
  {
    id: '217',
    question: 'In welchem Zeitraum gab es die Deutsche Demokratische Republik (DDR)?',
    answers: [
      {
        content: '1919 bis 1927',
        key: 0,
      },
      {
        content: '1933 bis 1945',
        key: 0,
      },
      {
        content: '1945 bis 1961',
        key: 0,
      },
      {
        content: '1949 bis 1990',
        key: 1,
      },
    ],
    category: 'Wichtige Stationen nach 1945',
  },
  {
    id: '218',
    question: 'Wie viele Bundesländer kamen bei der Wiedervereinigung 1990 zur Bundesrepublik Deutschland hinzu?',
    answers: [
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
      {
        content: '7',
        key: 0,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '219',
    question: 'Die Bundesrepublik Deutschland hat die Grenzen von heute seit ...',
    answers: [
      {
        content: '1933.',
        key: 0,
      },
      {
        content: '1949.',
        key: 0,
      },
      {
        content: '1971.',
        key: 0,
      },
      {
        content: '1990.',
        key: 1,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '220',
    question: 'Der 27. Januar ist in Deutschland ein offizieller Gedenktag. Woran erinnert dieser Tag?',
    answers: [
      {
        content: 'an das Ende des Zweiten Weltkrieges',
        key: 0,
      },
      {
        content: 'an die Verabschiedung des Grundgesetzes',
        key: 0,
      },
      {
        content: 'an die Wiedervereinigung Deutschlands',
        key: 0,
      },
      {
        content: 'an die Opfer des Nationalsozialismus',
        key: 1,
      },
    ],
    category: 'Der Nationalsozialismus und seine Folgen',
  },
  {
    id: '221',
    question: 'Deutschland ist Mitglied des Schengener Abkommens. Was bedeutet das?',
    answers: [
      {
        content: 'Deutsche können in viele Länder Europas ohne Passkontrolle reisen.',
        key: 1,
      },
      {
        content: 'Alle Menschen können ohne Personenkontrolle in Deutschland einreisen.',
        key: 0,
      },
      {
        content: 'Deutsche können ohne Passkontrolle in jedes Land reisen.',
        key: 0,
      },
      {
        content: 'Deutsche können in jedem Land mit dem Euro bezahlen.',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '222',
    question: 'Welches Land ist ein Nachbarland von Deutschland?',
    answers: [
      {
        content: 'Ungarn',
        key: 0,
      },
      {
        content: 'Portugal',
        key: 0,
      },
      {
        content: 'Spanien',
        key: 0,
      },
      {
        content: 'Schweiz',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '223',
    question: 'Welches Land ist ein Nachbarland von Deutschland?',
    answers: [
      {
        content: 'Rumänien',
        key: 0,
      },
      {
        content: 'Bulgarien',
        key: 0,
      },
      {
        content: 'Polen',
        key: 1,
      },
      {
        content: 'Griechenland',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '224',
    question: 'Was bedeutet die Abkürzung EU?',
    answers: [
      {
        content: 'Europäische Unternehmen',
        key: 0,
      },
      {
        content: 'Europäische Union',
        key: 1,
      },
      {
        content: 'Einheitliche Union',
        key: 0,
      },
      {
        content: 'Euro Union',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '225',
    question: 'In welchem anderen Land gibt es eine große deutschsprachige Bevölkerung?',
    answers: [
      {
        content: 'Tschechien',
        key: 0,
      },
      {
        content: 'Norwegen',
        key: 0,
      },
      {
        content: 'Spanien',
        key: 0,
      },
      {
        content: '\u00d6sterreich',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '226',
    question: 'Welche ist die Flagge der Europäischen Union?',
    image: '226',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '227',
    question: 'Welches Land ist ein Nachbarland von Deutschland?',
    answers: [
      {
        content: 'Finnland',
        key: 0,
      },
      {
        content: 'Dänemark',
        key: 1,
      },
      {
        content: 'Norwegen',
        key: 0,
      },
      {
        content: 'Schweden',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '228',
    question: 'Wie wird der Beitritt der DDR zur Bundesrepublik Deutschland im Jahr 1990 allgemein genannt?',
    answers: [
      {
        content: 'NATO-Osterweiterung',
        key: 0,
      },
      {
        content: 'EU-Osterweiterung',
        key: 0,
      },
      {
        content: 'Europäische Gemeinschaft',
        key: 0,
      },
      {
        content: 'Deutsche Wiedervereinigung',
        key: 1,
      },
    ],
    category: 'Wiedervereinigung',
  },
  {
    id: '229',
    question: 'Welches Land ist ein Nachbarland von Deutschland?',
    answers: [
      {
        content: 'Spanien',
        key: 0,
      },
      {
        content: 'Bulgarien',
        key: 0,
      },
      {
        content: 'Norwegen',
        key: 0,
      },
      {
        content: 'Luxemburg',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '230',
    question: 'Das Europäische Parlament wird regelmäßig gewählt, nämlich alle ...',
    answers: [
      {
        content: '5 Jahre.',
        key: 1,
      },
      {
        content: '6 Jahre.',
        key: 0,
      },
      {
        content: '7 Jahre.',
        key: 0,
      },
      {
        content: '8 Jahre.',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '231',
    question: 'Was bedeutet der Begriff \u201eeuropäische Integration\u201c?',
    answers: [
      {
        content: 'Damit sind amerikanische Einwanderer in Europa gemeint.',
        key: 0,
      },
      {
        content: 'Der Begriff meint den Einwanderungsstopp nach Europa.',
        key: 0,
      },
      {
        content: 'Damit sind europäische Auswanderer in den USA gemeint.',
        key: 0,
      },
      {
        content: 'Der Begriff meint den Zusammenschluss europäischer Staaten zur EU.',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '232',
    question: 'Wer wird bei der Europawahl gewählt?',
    answers: [
      {
        content: 'die Europäische Kommission',
        key: 0,
      },
      {
        content: 'die Länder, die in die EU eintreten dürfen',
        key: 0,
      },
      {
        content: 'die europäische Verfassung',
        key: 0,
      },
      {
        content: 'die Abgeordneten des Europäischen Parlaments',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '233',
    question: 'Welches Land ist ein Nachbarland von Deutschland?',
    answers: [
      {
        content: 'Tschechien',
        key: 1,
      },
      {
        content: 'Bulgarien',
        key: 0,
      },
      {
        content: 'Griechenland',
        key: 0,
      },
      {
        content: 'Portugal',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '234',
    question: 'Wo ist der Sitz des Europäischen Parlaments?',
    answers: [
      {
        content: 'London',
        key: 0,
      },
      {
        content: 'Paris',
        key: 0,
      },
      {
        content: 'Berlin',
        key: 0,
      },
      {
        content: 'Straßburg',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '235',
    question:
      'Der französische Staatspräsident Fran\u00e7ois Mitterrand und der deutsche Bundeskanzler Helmut Kohl gedenken in Verdun gemeinsam der Toten beider Weltkriege. Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich?',
    image: '235',
    answers: [
      {
        content: 'Freundschaft zwischen England und Deutschland',
        key: 0,
      },
      {
        content: 'Reisefreiheit in alle Länder der EU',
        key: 0,
      },
      {
        content: 'Frieden und Sicherheit in den Ländern der EU',
        key: 1,
      },
      {
        content: 'Einheitliche Feiertage in den Ländern der EU',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '236',
    question: 'Wie viele Mitgliedstaaten hat die EU heute?',
    answers: [
      {
        content: '21',
        key: 0,
      },
      {
        content: '23',
        key: 0,
      },
      {
        content: '25',
        key: 0,
      },
      {
        content: '27',
        key: 1,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '237',
    question:
      '2007 wurde das 50-jährige Jubiläum der \u201eRömischen Verträge\u201c gefeiert. Was war der Inhalt der Verträge?',
    answers: [
      {
        content: 'Beitritt Deutschlands zur NATO',
        key: 0,
      },
      {
        content: 'Gründung der Europäischen Wirtschaftsgemeinschaft (EWG)',
        key: 1,
      },
      {
        content: 'Verpflichtung Deutschlands zu Reparationsleistungen',
        key: 0,
      },
      {
        content: 'Festlegung der Oder-Neiße-Linie als Ostgrenze',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '238',
    question: 'An welchen Orten arbeitet das Europäische Parlament?',
    answers: [
      {
        content: 'Paris, London und Den Haag',
        key: 0,
      },
      {
        content: 'Straßburg, Luxemburg und Brüssel',
        key: 1,
      },
      {
        content: 'Rom, Bern und Wien',
        key: 0,
      },
      {
        content: 'Bonn, Zürich und Mailand',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '239',
    question:
      'Durch welche Verträge schloss sich die Bundesrepublik Deutschland mit anderen Staaten zur Europäischen Wirtschaftsgemeinschaft zusammen?',
    answers: [
      {
        content: 'durch die \u201eHamburger Verträge\u201c',
        key: 0,
      },
      {
        content: 'durch die \u201eRömischen Verträge\u201c',
        key: 1,
      },
      {
        content: 'durch die \u201ePariser Verträge\u201c',
        key: 0,
      },
      {
        content: 'durch die \u201eLondoner Verträge\u201c',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '240',
    question: 'Seit wann bezahlt man in Deutschland mit dem Euro in bar?',
    answers: [
      {
        content: '1995',
        key: 0,
      },
      {
        content: '1998',
        key: 0,
      },
      {
        content: '2002',
        key: 1,
      },
      {
        content: '2005',
        key: 0,
      },
    ],
    category: 'Deutschland in Europa',
  },
  {
    id: '241',
    question: 'Frau Seger bekommt ein Kind. Was muss sie tun, um Elterngeld zu erhalten?',
    answers: [
      {
        content: 'Sie muss an ihre Krankenkasse schreiben.',
        key: 0,
      },
      {
        content: 'Sie muss nichts tun, denn sie bekommt automatisch Elterngeld.',
        key: 0,
      },
      {
        content: 'Sie muss einen Antrag bei der Elterngeldstelle stellen.',
        key: 1,
      },
      {
        content: 'Sie muss das Arbeitsamt um Erlaubnis bitten.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '242',
    question: 'Wer entscheidet, ob ein Kind in Deutschland in den Kindergarten geht?',
    answers: [
      {
        content: 'der Staat',
        key: 0,
      },
      {
        content: 'die Bundesländer',
        key: 0,
      },
      {
        content: 'die Eltern/die Erziehungsberechtigten',
        key: 1,
      },
      {
        content: 'die Schulen',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '243',
    question:
      'Maik und Sybille wollen mit Freunden an ihrem deutschen Wohnort eine Demonstration auf der Straße abhalten. Was müssen sie vorher tun?',
    answers: [
      {
        content: 'Sie müssen nichts tun. Man darf in Deutschland jederzeit überall demonstrieren.',
        key: 0,
      },
      {
        content: 'Sie müssen die Demonstration anmelden.',
        key: 1,
      },
      {
        content: 'Sie können gar nichts tun, denn Demonstrationen sind in Deutschland grundsätzlich verboten.',
        key: 0,
      },
      {
        content: 'Maik und Sybille müssen einen neuen Verein gründen, weil nur Vereine demonstrieren dürfen.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '244',
    question: 'Welchen Schulabschluss braucht man normalerweise, um an einer Universität in Deutschland ein Studium zu beginnen?',
    answers: [
      {
        content: 'das Abitur',
        key: 1,
      },
      {
        content: 'ein Diplom',
        key: 0,
      },
      {
        content: 'die Prokura',
        key: 0,
      },
      {
        content: 'eine Gesellenprüfung',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '245',
    question: 'Wer darf in Deutschland nicht als Paar zusammenleben?',
    answers: [
      {
        content: 'Hans (20 Jahre) und Marie (19 Jahre)',
        key: 0,
      },
      {
        content: 'Tom (20 Jahre) und Klaus (45 Jahre)',
        key: 0,
      },
      {
        content: 'Sofie (35 Jahre) und Lisa (40 Jahre)',
        key: 0,
      },
      {
        content: 'Anne (13 Jahre) und Tim (25 Jahre)',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '246',
    question: 'Ab welchem Alter ist man in Deutschland volljährig?',
    answers: [
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '19',
        key: 0,
      },
      {
        content: '21',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '247',
    question:
      'Eine Frau ist schwanger. Sie ist kurz vor und nach der Geburt ihres Kindes vom Gesetz besonders geschützt. Wie heißt dieser Schutz?',
    answers: [
      {
        content: 'Elternzeit',
        key: 0,
      },
      {
        content: 'Geburtsvorbereitung',
        key: 0,
      },
      {
        content: 'Mutterschutz',
        key: 1,
      },
      {
        content: 'Wochenbett',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '248',
    question: 'Die Erziehung der Kinder ist in Deutschland vor allem Aufgabe ...',
    answers: [
      {
        content: 'des Staates.',
        key: 0,
      },
      {
        content: 'der Eltern.',
        key: 1,
      },
      {
        content: 'der Großeltern.',
        key: 0,
      },
      {
        content: 'der Schulen.',
        key: 0,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '249',
    question: 'Wer ist in Deutschland hauptsächlich verantwortlich für die Kindererziehung?',
    answers: [
      {
        content: 'der Staat',
        key: 0,
      },
      {
        content: 'die Eltern',
        key: 1,
      },
      {
        content: 'die Verwandten',
        key: 0,
      },
      {
        content: 'die Schulen',
        key: 0,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '250',
    question: 'In Deutschland hat man die besten Chancen auf einen gut bezahlten Arbeitsplatz, wenn man ...',
    answers: [
      {
        content: 'katholisch ist.',
        key: 0,
      },
      {
        content: 'gut ausgebildet ist.',
        key: 1,
      },
      {
        content: 'eine Frau ist.',
        key: 0,
      },
      {
        content: 'Mitglied einer Partei ist.',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '251',
    question: 'Wenn man in Deutschland ein Kind schlägt, ...',
    answers: [
      {
        content: 'geht das niemanden etwas an.',
        key: 0,
      },
      {
        content: 'geht das nur die Familie etwas an.',
        key: 0,
      },
      {
        content: 'kann man dafür nicht bestraft werden.',
        key: 0,
      },
      {
        content: 'kann man dafür bestraft werden.',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '252',
    question: 'In Deutschland ...',
    answers: [
      {
        content: 'darf man zur gleichen Zeit nur mit einem Partner / einer Partnerin verheiratet sein.',
        key: 1,
      },
      {
        content: 'kann man mehrere Ehepartner / Ehepartnerinnen gleichzeitig haben.',
        key: 0,
      },
      {
        content: 'darf man nicht wieder heiraten, wenn man einmal verheiratet war.',
        key: 0,
      },
      {
        content: 'darf eine Frau nicht wieder heiraten, wenn ihr Mann gestorben ist.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '253',
    question: 'Wo müssen Sie sich anmelden, wenn Sie in Deutschland umziehen?',
    answers: [
      {
        content: 'beim Einwohnermeldeamt',
        key: 1,
      },
      {
        content: 'beim Standesamt',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt',
        key: 0,
      },
      {
        content: 'beim Gewerbeamt',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '254',
    question:
      'In Deutschland dürfen Ehepaare sich scheiden lassen. Meistens müssen sie dazu das \u201eTrennungsjahr\u201c einhalten. Was bedeutet das?',
    answers: [
      {
        content: 'Der Scheidungsprozess dauert ein Jahr.',
        key: 0,
      },
      {
        content: 'Mann und Frau sind ein Jahr verheiratet, dann ist die Scheidung möglich.',
        key: 0,
      },
      {
        content: 'Das Besuchsrecht für die Kinder gilt ein Jahr.',
        key: 0,
      },
      {
        content: 'Mann und Frau führen mindestens ein Jahr getrennt ihr eigenes Leben. Danach ist die Scheidung möglich.',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '255',
    question: 'Bei Erziehungsproblemen können Eltern in Deutschland Hilfe erhalten vom ...',
    answers: [
      {
        content: 'Ordnungsamt.',
        key: 0,
      },
      {
        content: 'Schulamt.',
        key: 0,
      },
      {
        content: 'Jugendamt.',
        key: 1,
      },
      {
        content: 'Gesundheitsamt.',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '256',
    question: 'Ein Ehepaar möchte in Deutschland ein Restaurant eröffnen. Was braucht es dazu unbedingt?',
    answers: [
      {
        content: 'eine Erlaubnis der Polizei',
        key: 0,
      },
      {
        content: 'eine Genehmigung einer Partei',
        key: 0,
      },
      {
        content: 'eine Genehmigung des Einwohnermeldeamts',
        key: 0,
      },
      {
        content: 'eine Gaststättenerlaubnis von der zuständigen Behörde',
        key: 1,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '257',
    question: 'Eine erwachsene Frau möchte in Deutschland das Abitur nachholen. Das kann sie an ...',
    answers: [
      {
        content: 'einer Hochschule.',
        key: 0,
      },
      {
        content: 'einem Abendgymnasium.',
        key: 1,
      },
      {
        content: 'einer Hauptschule.',
        key: 0,
      },
      {
        content: 'einer Privatuniversität.',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '258',
    question: 'Was darf das Jugendamt in Deutschland?',
    answers: [
      {
        content: 'Es entscheidet, welche Schule das Kind besucht.',
        key: 0,
      },
      {
        content: 'Es kann ein Kind, das geschlagen wird oder hungern muss, aus der Familie nehmen.',
        key: 1,
      },
      {
        content: 'Es bezahlt das Kindergeld an die Eltern.',
        key: 0,
      },
      {
        content: 'Es kontrolliert, ob das Kind einen Kindergarten besucht.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '259',
    question: 'Das Berufsinformationszentrum BIZ bei der Bundesagentur für Arbeit in Deutschland hilft bei der ...',
    answers: [
      {
        content: 'Rentenberechnung.',
        key: 0,
      },
      {
        content: 'Lehrstellensuche.',
        key: 1,
      },
      {
        content: 'Steuererklärung.',
        key: 0,
      },
      {
        content: 'Krankenversicherung.',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '260',
    question: 'In Deutschland hat ein Kind in der Schule ...',
    answers: [
      {
        content: 'Recht auf unbegrenzte Freizeit.',
        key: 0,
      },
      {
        content: 'Wahlfreiheit für alle Fächer.',
        key: 0,
      },
      {
        content: 'Anspruch auf Schulgeld.',
        key: 0,
      },
      {
        content: 'Anwesenheitspflicht.',
        key: 1,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '261',
    question: 'Ein Mann möchte mit 30 Jahren in Deutschland sein Abitur nachholen. Wo kann er das tun? An ...',
    answers: [
      {
        content: 'einer Hochschule',
        key: 0,
      },
      {
        content: 'einem Abendgymnasium',
        key: 1,
      },
      {
        content: 'einer Hauptschule',
        key: 0,
      },
      {
        content: 'einer Privatuniversität',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '262',
    question: 'Was bedeutet in Deutschland der Grundsatz der Gleichbehandlung?',
    answers: [
      {
        content: 'Niemand darf z. B. wegen einer Behinderung benachteiligt werden.',
        key: 1,
      },
      {
        content: 'Man darf andere Personen benachteiligen, wenn ausreichende persönliche Gründe hierfür vorliegen.',
        key: 0,
      },
      {
        content: 'Niemand darf gegen Personen klagen, wenn sie benachteiligt wurden.',
        key: 0,
      },
      {
        content: 'Es ist für alle Gesetz, benachteiligten Gruppen jährlich Geld zu spenden.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '263',
    question:
      'In Deutschland sind Jugendliche ab 14 Jahren strafmündig. Das bedeutet: Jugendliche, die 14 Jahre und älter sind und gegen Strafgesetze verstoßen, ...',
    answers: [
      {
        content: 'werden bestraft.',
        key: 1,
      },
      {
        content: 'werden wie Erwachsene behandelt.',
        key: 0,
      },
      {
        content: 'teilen die Strafe mit ihren Eltern.',
        key: 0,
      },
      {
        content: 'werden nicht bestraft.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '264',
    question: 'Zu welchem Fest tragen Menschen in Deutschland bunte Kostüme und Masken?',
    answers: [
      {
        content: 'am Rosenmontag',
        key: 1,
      },
      {
        content: 'am Maifeiertag',
        key: 0,
      },
      {
        content: 'beim Oktoberfest',
        key: 0,
      },
      {
        content: 'an Pfingsten',
        key: 0,
      },
    ],
    category: 'Interkulturelles Zusammenleben',
  },
  {
    id: '265',
    question: 'Wohin muss man in Deutschland zuerst gehen, wenn man heiraten möchte?',
    answers: [
      {
        content: 'zum Einwohnermeldeamt',
        key: 0,
      },
      {
        content: 'zum Ordnungsamt',
        key: 0,
      },
      {
        content: 'zur Agentur für Arbeit',
        key: 0,
      },
      {
        content: 'zum Standesamt',
        key: 1,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '266',
    question: 'Wann beginnt die gesetzliche Nachtruhe in Deutschland?',
    answers: [
      {
        content: 'wenn die Sonne untergeht',
        key: 0,
      },
      {
        content: 'um 0 Uhr, Mitternacht',
        key: 0,
      },
      {
        content: 'wenn die Nachbarn schlafen gehen',
        key: 0,
      },
      {
        content: 'um 22 Uhr',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '267',
    question:
      'Eine junge Frau in Deutschland, 22 Jahre alt, lebt mit ihrem Freund zusammen. Die Eltern der Frau finden das nicht gut, weil ihnen der Freund nicht gefällt. Was können die Eltern tun?',
    answers: [
      {
        content: 'Sie müssen die Entscheidung der volljährigen Tochter respektieren.',
        key: 1,
      },
      {
        content: 'Sie haben das Recht, die Tochter in die elterliche Wohnung zurückzuholen.',
        key: 0,
      },
      {
        content: 'Sie können zur Polizei gehen und die Tochter anzeigen.',
        key: 0,
      },
      {
        content: 'Sie suchen einen anderen Mann für die Tochter.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '268',
    question:
      'Eine junge Frau will den Führerschein machen. Sie hat Angst vor der Prüfung weil ihre Muttersprache nicht Deutsch ist. Was ist richtig?',
    answers: [
      {
        content: 'Sie muss mindestens zehn Jahre in Deutschland leben, bevor sie den Führerschein machen kann.',
        key: 0,
      },
      {
        content: 'Sie kann die Theorie-Prüfung vielleicht in ihrer Muttersprache machen. Es gibt mehr als zehn Sprachen zur Auswahl.',
        key: 1,
      },
      {
        content: 'Wenn sie kein Deutsch kann, darf sie keinen Führerschein haben.',
        key: 0,
      },
      {
        content: 'Sie muss den Führerschein in dem Land machen, in dem man ihre Sprache spricht.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '269',
    question: 'In Deutschland haben Kinder ab dem Alter von drei Jahren bis zur Ersteinschulung einen Anspruch auf ...',
    answers: [
      {
        content: 'monatliches Taschengeld.',
        key: 0,
      },
      {
        content: 'einen Kindergartenplatz.',
        key: 1,
      },
      {
        content: 'einen Platz in einem Sportverein.',
        key: 0,
      },
      {
        content: 'einen Ferienpass.',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '270',
    question: 'Die Volkshochschule in Deutschland ist eine Einrichtung ...',
    answers: [
      {
        content: 'für den Religionsunterricht.',
        key: 0,
      },
      {
        content: 'nur für Jugendliche.',
        key: 0,
      },
      {
        content: 'zur Weiterbildung.',
        key: 1,
      },
      {
        content: 'nur für Rentner und Rentnerinnen.',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '271',
    question: 'Was ist in Deutschland ein Brauch zu Weihnachten?',
    answers: [
      {
        content: 'bunte Eier verstecken',
        key: 0,
      },
      {
        content: 'einen Tannenbaum schmücken',
        key: 1,
      },
      {
        content: 'sich mit Masken und Kostümen verkleiden',
        key: 0,
      },
      {
        content: 'Kürbisse vor die Tür stellen',
        key: 0,
      },
    ],
    category: 'Interkulturelles Zusammenleben',
  },
  {
    id: '272',
    question: 'Welche Lebensform ist in Deutschland nicht erlaubt?',
    answers: [
      {
        content: 'Mann und Frau sind geschieden und leben mit neuen Partnern zusammen.',
        key: 0,
      },
      {
        content: 'Zwei Frauen leben zusammen.',
        key: 0,
      },
      {
        content: 'Ein allein erziehender Vater lebt mit seinen zwei Kindern zusammen.',
        key: 0,
      },
      {
        content: 'Ein Mann ist mit zwei Frauen zur selben Zeit verheiratet.',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '273',
    question: 'Bei Erziehungsproblemen gehen Sie in Deutschland ...',
    answers: [
      {
        content: 'zum Arzt / zur Ärztin.',
        key: 0,
      },
      {
        content: 'zum Gesundheitsamt.',
        key: 0,
      },
      {
        content: 'zum Einwohnermeldeamt.',
        key: 0,
      },
      {
        content: 'zum Jugendamt.',
        key: 1,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '274',
    question:
      'Sie haben in Deutschland absichtlich einen Brief geöffnet, der an eine andere Person adressiert ist. Was haben Sie nicht beachtet?',
    answers: [
      {
        content: 'das Schweigerecht',
        key: 0,
      },
      {
        content: 'das Briefgeheimnis',
        key: 1,
      },
      {
        content: 'die Schweigepflicht',
        key: 0,
      },
      {
        content: 'die Meinungsfreiheit',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '275',
    question: 'Was braucht man in Deutschland für eine Ehescheidung?',
    answers: [
      {
        content: 'die Einwilligung der Eltern',
        key: 0,
      },
      {
        content: 'ein Attest eines Arztes / einer Ärztin',
        key: 0,
      },
      {
        content: 'die Einwilligung der Kinder',
        key: 0,
      },
      {
        content: 'die Unterstützung eines Anwalts / einer Anwältin',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '276',
    question:
      'Was sollten Sie tun, wenn Sie von Ihrem Ansprechpartner / Ihrer Ansprechpartnerin in einer deutschen Behörde schlecht behandelt werden?',
    answers: [
      {
        content: 'Ich kann nichts tun.',
        key: 0,
      },
      {
        content: 'Ich muss mir diese Behandlung gefallen lassen.',
        key: 0,
      },
      {
        content: 'Ich drohe der Person.',
        key: 0,
      },
      {
        content: 'Ich kann mich beim Behördenleiter / bei der Behördenleiterin beschweren.',
        key: 1,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '277',
    question:
      'Eine Frau, die ein zweijähriges Kind hat, bewirbt sich in Deutschland um eine Stelle. Was ist ein Beispiel für Diskriminierung? Sie bekommt die Stelle nur deshalb nicht, weil sie ...',
    answers: [
      {
        content: 'kein Englisch spricht.',
        key: 0,
      },
      {
        content: 'zu hohe Gehaltsvorstellungen hat.',
        key: 0,
      },
      {
        content: 'keine Erfahrungen in diesem Beruf hat.',
        key: 0,
      },
      {
        content: 'Mutter ist.',
        key: 1,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '278',
    question:
      'Ein Mann im Rollstuhl hat sich auf eine Stelle als Buchhalter beworben. Was ist ein Beispiel für Diskriminierung? Er bekommt die Stelle nur deshalb nicht, weil er ...',
    answers: [
      {
        content: 'im Rollstuhl sitzt.',
        key: 1,
      },
      {
        content: 'keine Erfahrung hat.',
        key: 0,
      },
      {
        content: 'zu hohe Gehaltsvorstellungen hat.',
        key: 0,
      },
      {
        content: 'kein Englisch spricht.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '279',
    question:
      'In den meisten Mietshäusern in Deutschland gibt es eine \u201eHausordnung\u201c. Was steht in einer solchen \u201eHausordnung\u201c? Sie nennt ...',
    answers: [
      {
        content: 'Regeln für die Benutzung öffentlicher Verkehrsmittel.',
        key: 0,
      },
      {
        content: 'alle Mieter und Mieterinnen im Haus.',
        key: 0,
      },
      {
        content: 'Regeln, an die sich alle Bewohner und Bewohnerinnen halten müssen.',
        key: 1,
      },
      {
        content: 'die Adresse des nächsten Ordnungsamtes.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '280',
    question: 'Wenn Sie sich in Deutschland gegen einen falschen Steuerbescheid wehren wollen, müssen Sie ...',
    answers: [
      {
        content: 'nichts machen.',
        key: 0,
      },
      {
        content: 'den Bescheid wegwerfen.',
        key: 0,
      },
      {
        content: 'Einspruch einlegen.',
        key: 1,
      },
      {
        content: 'warten, bis ein anderer Bescheid kommt.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '281',
    question:
      'Zwei Freunde wollen in ein öffentliches Schwimmbad in Deutschland. Beide haben eine dunkle Hautfarbe und werden deshalb nicht hineingelassen. Welches Recht wird in dieser Situation verletzt? Das Recht auf ...',
    answers: [
      {
        content: 'Meinungsfreiheit',
        key: 0,
      },
      {
        content: 'Gleichbehandlung',
        key: 1,
      },
      {
        content: 'Versammlungsfreiheit',
        key: 0,
      },
      {
        content: 'Freizügigkeit',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '282',
    question:
      'Welches Ehrenamt müssen deutsche Staatsbürger / Staatsbürgerinnen übernehmen, wenn sie dazu aufgefordert werden?',
    answers: [
      {
        content: 'Vereinstrainer / Vereinstrainerin',
        key: 0,
      },
      {
        content: 'Bibliotheksaufsicht',
        key: 0,
      },
      {
        content: 'Wahlhelfer / Wahlhelferin',
        key: 1,
      },
      {
        content: 'Lehrer / Lehrerin',
        key: 0,
      },
    ],
    category: 'Pflichten',
  },
  {
    id: '283',
    question: 'Was tun Sie, wenn Sie eine falsche Rechnung von einer deutschen Behörde bekommen?',
    answers: [
      {
        content: 'Ich lasse die Rechnung liegen.',
        key: 0,
      },
      {
        content: 'Ich lege Widerspruch bei der Behörde ein.',
        key: 1,
      },
      {
        content: 'Ich schicke die Rechnung an die Behörde zurück.',
        key: 0,
      },
      {
        content: 'Ich gehe mit der Rechnung zum Finanzamt.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '284',
    question: 'Was man für die Arbeit können muss, ändert sich in der Zukunft sehr schnell. Was kann man tun?',
    answers: [
      {
        content: 'Es ist egal, was man lernt.',
        key: 0,
      },
      {
        content: 'Kinder lernen in der Schule alles, was im Beruf wichtig ist. Nach der Schule muss man nicht weiter lernen.',
        key: 0,
      },
      {
        content: 'Erwachsene müssen auch nach der Ausbildung immer weiter lernen.',
        key: 1,
      },
      {
        content: 'Alle müssen früher aufhören zu arbeiten, weil sich alles ändert.',
        key: 0,
      },
    ],
    category: 'Bildung',
  },
  {
    id: '285',
    question: 'Frau Frost arbeitet als fest angestellte Mitarbeiterin in einem Büro. Was muss sie nicht von ihrem Gehalt bezahlen?',
    answers: [
      {
        content: 'Umsatzsteuer',
        key: 1,
      },
      {
        content: 'Lohnsteuer',
        key: 0,
      },
      {
        content: 'Beiträge zur Arbeitslosenversicherung',
        key: 0,
      },
      {
        content: 'Beiträge zur Renten- und Krankenversicherung',
        key: 0,
      },
    ],
    category: 'Sozialsystem',
  },
  {
    id: '286',
    question:
      'Welche Organisation in einer Firma hilft den Arbeitnehmern und Arbeitnehmerinnen bei Problemen mit dem Arbeitgeber / der Arbeitgeberin?',
    answers: [
      {
        content: 'der Betriebsrat',
        key: 1,
      },
      {
        content: 'der Betriebsprüfer / die Betriebsprüferin',
        key: 0,
      },
      {
        content: 'die Betriebsgruppe',
        key: 0,
      },
      {
        content: 'das Betriebsmanagement',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '287',
    question: 'Sie möchten bei einer Firma in Deutschland Ihr Arbeitsverhältnis beenden. Was müssen Sie beachten?',
    answers: [
      {
        content: 'die Gehaltszahlungen',
        key: 0,
      },
      {
        content: 'die Arbeitszeit',
        key: 0,
      },
      {
        content: 'die Kündigungsfrist',
        key: 1,
      },
      {
        content: 'die Versicherungspflicht',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '288',
    question: 'Bei welchem Amt muss man in Deutschland in der Regel seinen Hund anmelden?',
    answers: [
      {
        content: 'beim Finanzamt',
        key: 0,
      },
      {
        content: 'beim Einwohnermeldeamt',
        key: 0,
      },
      {
        content: 'bei der Kommune (Stadt oder Gemeinde)',
        key: 1,
      },
      {
        content: 'beim Gesundheitsamt',
        key: 0,
      },
    ],
    category: 'Kommune',
  },
  {
    id: '289',
    question:
      'Ein Mann mit dunkler Hautfarbe bewirbt sich um eine Stelle als Kellner in einem Restaurant in Deutschland. Was ist ein Beispiel für Diskriminierung? Er bekommt die Stelle nur deshalb nicht, weil ...',
    answers: [
      {
        content: 'seine Deutschkenntnisse zu gering sind.',
        key: 0,
      },
      {
        content: 'er zu hohe Gehaltsvorstellungen hat.',
        key: 0,
      },
      {
        content: 'er eine dunkle Haut hat.',
        key: 1,
      },
      {
        content: 'er keine Erfahrungen im Beruf hat.',
        key: 0,
      },
    ],
    category: 'Grundrechte',
  },
  {
    id: '290',
    question:
      'Sie haben in Deutschland einen Fernseher gekauft. Zu Hause packen Sie den Fernseher aus, doch er funktioniert nicht. Der Fernseher ist kaputt. Was können Sie machen?',
    answers: [
      {
        content: 'eine Anzeige schreiben',
        key: 0,
      },
      {
        content: 'den Fernseher reklamieren',
        key: 1,
      },
      {
        content: 'das Gerät ungefragt austauschen',
        key: 0,
      },
      {
        content: 'die Garantie verlängern',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '291',
    question:
      'Warum muss man in Deutschland bei der Steuererklärung aufschreiben, ob man zu einer Kirche gehört oder nicht? Weil ...',
    answers: [
      {
        content: 'das für die Statistik in Deutschland wichtig ist.',
        key: 0,
      },
      {
        content: 'es eine Kirchensteuer gibt, die an die Einkommen- und Lohnsteuer geknüpft ist.',
        key: 1,
      },
      {
        content: 'man mehr Steuern zahlen muss, wenn man nicht zu einer Kirche gehört.',
        key: 0,
      },
      {
        content: 'die Kirche für die Steuererklärung verantwortlich ist.',
        key: 0,
      },
    ],
    category: 'Recht und Alltag',
  },
  {
    id: '292',
    question: 'Die Menschen in Deutschland leben nach dem Grundsatz der religiösen Toleranz. Was bedeutet das?',
    answers: [
      {
        content: 'Es dürfen keine Moscheen gebaut werden.',
        key: 0,
      },
      {
        content: 'Alle Menschen glauben an Gott.',
        key: 0,
      },
      {
        content: 'Jeder kann glauben, was er möchte.',
        key: 1,
      },
      {
        content: 'Der Staat entscheidet, an welchen Gott die Menschen glauben.',
        key: 0,
      },
    ],
    category: 'Religiöse Vielfalt',
  },
  {
    id: '293',
    question: 'Was ist in Deutschland ein Brauch an Ostern?',
    answers: [
      {
        content: 'Kürbisse vor die Tür stellen',
        key: 0,
      },
      {
        content: 'einen Tannenbaum schmücken',
        key: 0,
      },
      {
        content: 'Eier bemalen',
        key: 1,
      },
      {
        content: 'Raketen in die Luft schießen',
        key: 0,
      },
    ],
    category: 'Interkulturelles Zusammenleben',
  },
  {
    id: '294',
    question: 'Pfingsten ist ein ...',
    answers: [
      {
        content: 'christlicher Feiertag.',
        key: 1,
      },
      {
        content: 'deutscher Gedenktag.',
        key: 0,
      },
      {
        content: 'internationaler Trauertag.',
        key: 0,
      },
      {
        content: 'bayerischer Brauch.',
        key: 0,
      },
    ],
    category: 'Religiöse Vielfalt',
  },
  {
    id: '295',
    question: 'Welche Religion hat die europäische und deutsche Kultur geprägt?',
    answers: [
      {
        content: 'der Hinduismus',
        key: 0,
      },
      {
        content: 'das Christentum',
        key: 1,
      },
      {
        content: 'der Buddhismus',
        key: 0,
      },
      {
        content: 'der Islam',
        key: 0,
      },
    ],
    category: 'Religiöse Vielfalt',
  },
  {
    id: '296',
    question: 'In Deutschland nennt man die letzten vier Wochen vor Weihnachten ...',
    answers: [
      {
        content: 'den Buß- und Bettag.',
        key: 0,
      },
      {
        content: 'das Erntedankfest.',
        key: 0,
      },
      {
        content: 'die Adventszeit.',
        key: 1,
      },
      {
        content: 'Allerheiligen.',
        key: 0,
      },
    ],
    category: 'Religiöse Vielfalt',
  },
  {
    id: '297',
    question: 'Aus welchem Land sind die meisten Migranten / Migrantinnen nach Deutschland gekommen?',
    answers: [
      {
        content: 'Italien',
        key: 0,
      },
      {
        content: 'Polen',
        key: 0,
      },
      {
        content: 'Marokko',
        key: 0,
      },
      {
        content: 'Türkei',
        key: 1,
      },
    ],
    category: 'Migrationsgeschichte',
  },
  {
    id: '298',
    question: 'In der DDR lebten vor allem Migranten aus ...',
    answers: [
      {
        content: 'Vietnam, Polen, Mosambik.',
        key: 1,
      },
      {
        content: 'Frankreich, Rumänien, Somalia.',
        key: 0,
      },
      {
        content: 'Chile, Ungarn, Simbabwe.',
        key: 0,
      },
      {
        content: 'Nordkorea, Mexiko, Ägypten.',
        key: 0,
      },
    ],
    category: 'Migrationsgeschichte',
  },
  {
    id: '299',
    question:
      'Ausländische Arbeitnehmer und Arbeitnehmerinnen, die in den 50er und 60er Jahren von der Bundesrepublik Deutschland angeworben wurden, nannte man ...',
    answers: [
      {
        content: 'Schwarzarbeiter / Schwarzarbeiterinnen',
        key: 0,
      },
      {
        content: 'Gastarbeiter / Gastarbeiterinnen',
        key: 1,
      },
      {
        content: 'Zeitarbeiter / Zeitarbeiterinnen',
        key: 0,
      },
      {
        content: 'Schichtarbeiter / Schichtarbeiterinnen',
        key: 0,
      },
    ],
    category: 'Migrationsgeschichte',
  },
  {
    id: '300',
    question: 'Aus welchem Land kamen die ersten Gastarbeiter / Gastarbeiterinnen nach Deutschland?',
    answer_type: 'single',
    answers: [
      {
        content: 'Italien',
        key: 1,
      },
      {
        content: 'Spanien',
        key: 0,
      },
      {
        content: 'Portugal',
        key: 0,
      },
      {
        content: 'Türkei',
        key: 0,
      },
    ],
    category: 'Migrationsgeschichte',
  },
]

export default quizQuestions
